<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-9">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h5>
                        <div class="loader" v-if="waiting"></div>

                        <form v-if="post">
                            <div class="row">

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="post.category_id"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-if="c.id !== 999" v-for="c in categories" v-bind:value="c.id">
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="post.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Опубликовано</option>
                                            <option value="0">Ожидает</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Минимальная версия Muse</label>
                                        <select v-model="post.v" class="form-control">
                                            <option value="">Все версии</option>
                                            <option
                                                v-for="version in versions"
                                                :key="version"
                                                :value="version"
                                            >
                                                {{ version }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Минимальная версия Nola</label>
                                        <select v-model="post.v_nola" class="form-control">
                                            <option value="">Все версии</option>
                                            <option
                                                v-for="version in nolaVersions"
                                                :key="'nola-' + version"
                                                :value="version"
                                            >
                                                {{ version }}
                                            </option>
                                        </select>
                                    </div>
<!--                                    <div class="form-group">-->
<!--                                        <label class="control-label">Тип шаблона</label>-->
<!--                                        <select v-model="post.type"-->
<!--                                                id="status-control"-->
<!--                                                aria-describedby="addon-right addon-left"-->
<!--                                                class="form-control">-->
<!--                                            <option value="0">Пост</option>-->
<!--                                            <option value="1">Карусель</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
                                    <div class="form-group">
                                        <label class="control-label">Формат</label>
                                        <select v-model="post.ratio"
                                                id="ratio-control"
                                                @change="changeRatioType()"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">4:5</option>
                                            <option value="2">4:3</option>
                                            <option value="3">9:16</option>
                                            <option value="4">1:1</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Количество медиа"
                                              :value="calculatedMediaCount"
                                              disabled>
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="post.sort"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Сортировка Nola (чем больше, тем выше в списке)"
                                              v-model="post.sort_nola"
                                              placeholder="">
                                    </fg-input>
                                </div>

                                <div class="col-md-8">
                                    <div class="row">
                                        <div class="col-md-5 checkbox-block">
                                            <div class="form-group">
                                                <label for="premium-control"
                                                       class="control-label label-checkbox">Премиум</label>
                                                <input v-model="post.is_premium" id="premium-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="trendy-control"
                                                       class="control-label label-checkbox">Популярное</label>
                                                <input v-model="post.is_trendy" id="trendy-control"
                                                       class="form-check-inline"
                                                       type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="new-control"
                                                       class="control-label label-checkbox">Новое</label>
                                                <input v-model="post.is_new" id="new-control"
                                                       class="form-check-inline"
                                                       type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label class="control-label">Цвет фона: <span class="param-span">{{
                                                        post.background
                                                    }}</span></label>
                                                <input type="color" v-model="post.background">
                                                <fg-input type="text"
                                                          label=""
                                                          v-model="post.background"
                                                          placeholder="">
                                                </fg-input>
                                            </div>
                                        </div>

                                        <div class="col-md-1"></div>
                                        <div class="col-md-5">

                                            <div class="margin-top">
                                                <h5 slot="header" class="card-title">
                                                    Превью: <span v-if="post.preview_src">
                                            <span class="inline-link">
                                                <span v-if="post.preview_src_size >= 1"
                                                      class="bg-danger">{{ post.preview_src_size }}Mb</span>
                                                <span v-else-if="post.preview_src_size >= 0.5"
                                                      class="bg-warning">{{ post.preview_src_size }}Mb</span>
                                                <span v-else>{{ post.preview_src_size }}Mb</span>
                                                <a :href="post.preview_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                                </h5>

                                                <img @click.prevent="openResource(post.preview_src_full)"
                                                     :src="post.preview_src_full" class="preview-img device-block device1">

                                                <div>
                                                    <input ref="previewFileInput" class="btn-file" type="file"
                                                           @change="uploadFile($event, 'preview_src')">
                                                    <button type="button" class="btn btn-info btn-fill upload-button"
                                                            @click="$refs.previewFileInput.click()">
                                                        Загрузить
                                                    </button>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!--                            <div class="text-center">-->
                            <!--                                <div class="btn btn-danger btn-fill float-left btn-save"-->
                            <!--                                     @dblclick="remove()">-->
                            <!--                                    Удалить-->
                            <!--                                </div>-->
                            <!--                            </div>-->

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!post.category_id || !post.preview_src "
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                                <button type="submit" class="btn btn-danger btn-fill float-right btn-delete"
                                        @click.prevent="remove">
                                    Удалить шаблон
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>
                <div class="col-md-3">

                </div>
                <div class="col-md-12" v-if="template">

                    <!--"888"-->
                    <div class="modal-mask" v-if="show_collage_modal" @click="closeCollageModal">
                        <div class="modal-wrapper">
                            <div class="modal-container">

                                <div class="modal-header">
                                    <slot name="header">
                                        <button v-for="(t, index) in collages"
                                                type="button" class="btn btn-text btn-fill collage-category"
                                                :class="{ 'active' : t.name === active_collage_category}"
                                                @click="selectCollageCategory(t.name)">
                                            {{ t.name }}
                                        </button>
                                    </slot>
                                </div>

                                <div class="modal-body">
                                    <slot ref="collage" name="body">
                                        <div v-for="(t, index) in collages">
                                            <div v-for="(c, index) in t.data"
                                                 v-if="t.name === active_collage_category"
                                                 class="collage-item" >
                                                <div @click="addCollage" v-html="renderCollage(c)"></div>

                                            </div>
                                        </div>
                                    </slot>
                                </div>

                                <div class="modal-footer">
                                    <slot name="footer">
                                        <button class="btn btn-info btn-fill modal-close-button"
                                                @click="closeCollageModal">
                                            Закрыть
                                        </button>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>

                    <card>

                        <h4 slot="header" class="card-title">
                            Настройка шаблона ({{ post.parts.length }} слайдов)</h4>

                        <div v-for="(p, index) in post.parts"
                             class="preview-slide"
                             :class="{ 'active' : index === active_part_index }"
                             :style="{ backgroundImage: 'url(' + p.src_full + ')', height: previewSlideHeight + 'px' }"
                             @click="selectPart(index)">
                        </div>
                        <div class="preview-slide add-part"
                             :style="{ height: previewSlideHeight + 'px' }"
                             @click="addPart()">
                        </div>

                        <div class="clearfix"></div>
                        <div class="row margin-top bordered-block">
                            <div class="col-md-2">
                                <h5 slot="header" class="card-title">
                                    Превью: <span v-if="template.src">
                                            <span class="inline-link">
                                                <span v-if="template.src_size >= 1"
                                                      class="bg-danger">{{ template.src_size }}Mb</span>
                                                <span v-else-if="template.src_size >= 0.5"
                                                      class="bg-warning">{{ template.src_size }}Mb</span>
                                                <span v-else>{{ template.src_size }}Mb</span>
                                                <a :href="template.src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                </h5>
                                <div>
                                    <input ref="srcPreviewFileInput" class="btn-file" type="file"
                                           @change="uploadFile($event, 'src')">
                                    <button type="button" class="btn btn-info btn-fill upload-button"
                                            @click="$refs.srcPreviewFileInput.click()">
                                        Загрузить
                                    </button>
                                    <div class="clearfix"></div>
                                </div>
                                <div class="form-group" style="margin-top: 10px" v-if="template.src">
                                    <label for="video-preview-control"
                                           class="control-label label-checkbox">Видеопревью</label>
                                    <input v-model="template.video_preview" id="video-preview-control"
                                           class="form-check-inline" type="checkbox"
                                           @change="toggleVideoPreview">
                                </div>
                                <div v-if="template.src && template.video_preview">
                                    <h5 slot="header" class="card-title">
                                        Видео: <span v-if="template.video_src">
                                            <span class="inline-link">
                                                <span v-if="template.video_src_size >= 1"
                                                      class="bg-danger">{{ template.video_src_size }}Mb</span>
                                                <span v-else-if="template.video_src_size >= 0.5"
                                                      class="bg-warning">{{ template.video_src_size }}Mb</span>
                                                <span v-else>{{ template.video_src_size }}Mb</span>
                                                <a :href="template.video_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                    </h5>
                                    <input ref="videoSrcFileInput" class="btn-file" type="file"
                                           accept="video/*"
                                           @change="uploadFile($event, 'video_src')">
                                    <button type="button" class="btn btn-info btn-fill upload-button"
                                            @click="$refs.videoSrcFileInput.click()">
                                        Загрузить видео
                                    </button>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                            <div class="col-md-2">
                            <fg-input  type="text"
                                      label="Номер слайда (от 1 до N)"
                                      v-model="template.n"
                                       @input="updatePartsOrder"
                                      placeholder="">
                            </fg-input>
                            </div>
                            <div class="col-md-2">
                                <div class="clearfix"></div>
                                <button type="button" class="btn btn-remove mt25"
                                        @click="removePart()">Удалить слайд
                                </button>
                            </div>
                            <div class="col-md-2">
                                <button type="button" style="margin-top: 25px" class="btn btn-text btn-fill active control-btn"
                                        @click="copyPart()">Дублировать слайд
                                </button>
                            </div>

                        </div>

                        <div class="texts-buttons" v-if="template">
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="addLayout()">Добавить layout
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="addText()">Добавить текст
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="addText(false, true)">Добавить tool
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="showSVGModal()">Добавить объект
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="showFramesModal()">Добавить фрейм
                            </button>
                        </div>

                        <div class="texts-buttons layers-sticky" ref="layersBar" v-if="template">
                            <button v-for="(t, index) in template.layouts"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_layout && active_type === 'layout'}"
                                    @click="selectLayout(index)">Layout {{ index + 1 }}
                            </button>
                            <button v-for="(t, index) in template.texts"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_text && active_type === 'text'}"
                                    @click="selectText(index)">{{ t.text }}
                                <span class="animated-icon" v-if="t.animation_type !== 0">•</span>
                            </button>
                            <button v-for="(t, index) in template.objects"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_object && active_type === 'object'}"
                                    @click="selectObject(index)">
                                <div class="button-preview"
                                     :style="{ backgroundImage: 'url(\'' + objectPlayerSrc(t) + '\')' }">
                                </div>
                                <span class="animated-icon" v-if="t.animation_type !== 0">•</span>
                            </button>
                            <button v-for="(t, index) in template.frames"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_frame && active_type === 'frame'}"
                                    @click="selectFrame(index)">
                                <div class="button-preview"
                                     :style="{ backgroundImage: 'url(' + framesUrl + t.src + ')' }">
                                </div>
                            </button>
                            <button v-if="active_type === 'text' || active_type === 'layout' || active_type === 'object' || active_type === 'frame'" type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="active_type === 'text' ? addText(active_text) : active_type === 'layout' ? addLayout(active_layout) : active_type === 'frame' ? addFrame(null, active_frame) : addObject(null, active_object)">
                                Копировать
                            </button>
                        </div>

                        <div class="modal-mask" v-if="show_svg_modal" @click="closeSVGModal">
                            <div class="modal-wrapper">
                                <div class="modal-container">

                                    <div class="modal-header">
                                        <slot name="header">
                                            <button v-for="(t, index) in server_graphics"
                                                    type="button" class="btn btn-text btn-fill"
                                                    :class="{ 'active' : t.name === active_object_category}"
                                                    @click="selectObjectCategory(t.name)">
                                                {{ t.name }}
                                            </button>
                                        </slot>
                                    </div>

                                    <div class="modal-body">
                                        <slot name="body">
                                            <div v-for="(t, index) in server_graphics">
                                                <div v-for="(c, index) in t.data"
                                                     v-if="t.name === active_object_category"
                                                     class="object-item"
                                                     @click="addObject(c)">
                                                    <img :src="`${graphicsUrl}${c.src}`" class="image">
                                                </div>
                                            </div>
                                        </slot>
                                    </div>

                                    <div class="modal-footer">
                                        <slot name="footer">
                                            <button class="btn btn-info btn-fill modal-close-button"
                                                    @click="closeSVGModal">
                                                Закрыть
                                            </button>
                                        </slot>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-mask" v-if="show_frames_modal" @click="closeFramesModal">
                            <div class="modal-wrapper">
                                <div class="modal-container">

                                    <div class="modal-header">
                                        <slot name="header">
                                            <button v-for="(t, index) in server_frames"
                                                    type="button" class="btn btn-text btn-fill"
                                                    :class="{ 'active' : t.id === active_frame_category}"
                                                    @click="selectFrameCategory(t.id)">
                                                {{ t.name }}
                                            </button>
                                        </slot>
                                    </div>

                                    <div class="modal-body" style="background: #C9D5DF;">
                                        <slot name="body">
                                            <div v-for="(t, index) in server_frames">
                                                <div v-for="(f, index) in t.data"
                                                     v-if="t.id === active_frame_category"
                                                     class="frame-item"
                                                     @click="addFrame(f)">
                                                    <img :src="`${f.src_full}`" class="image">
                                                </div>
                                            </div>
                                        </slot>
                                    </div>

                                    <div class="modal-footer">
                                        <slot name="footer">
                                            <button class="btn btn-info btn-fill modal-close-button"
                                                    @click="closeFramesModal">
                                                Закрыть
                                            </button>
                                        </slot>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <form>
                            <div class="loader" v-if="waiting"></div>

                            <div class="loader" v-if="textWaiting"></div>

                            <div class="row">
                                <div class="col-md-3 c-labels" v-if="active_type === 'layout' && template && template.layouts[active_layout]">

                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.layouts[active_layout].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.layouts[active_layout].alpha"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.layouts[active_layout].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <div class="form-group">
                                        <label for="content-control"
                                               class="control-label label-checkbox">Контент</label>
                                        <input v-model="template.layouts[active_layout].is_content" id="content-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="" v-if="template.layouts[active_layout].is_content">
                                        <h5 slot="header" class="card-title" v-if="template.layouts[active_layout].co && !isColor(template.layouts[active_layout].co)">
                                            Превью: <span>
                                            <span class="inline-link">
                                                <span v-if="template.layouts[active_layout].co_size >= 1"
                                                      class="bg-danger">{{ template.layouts[active_layout].co_size }}Mb</span>
                                                <span v-else-if="template.layouts[active_layout].co_size >= 0.5"
                                                      class="bg-warning">{{ template.layouts[active_layout].co_size }}Mb</span>
                                                <span v-else>{{ template.layouts[active_layout].co_size }}Mb</span>
                                                <a :href="template.layouts[active_layout].co_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                            <div class="form-group mt-1">
                                                <label for="content-control"
                                                       class="control-label label-checkbox">Фон</label>
                                                <input v-model="template.layouts[active_layout].is_bg" id="content-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                        </h5>
                                        <div>
                                            <input ref="coSrcPreviewFileInput" class="btn-file" type="file"
                                                   @change="uploadFile($event, 'co')">
                                            <button type="button" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.coSrcPreviewFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                        <div>
                                            <div class="mt25">
                                                <div class="form-group">
                                                    <label class="control-label">Цвет: <span v-if="isColor(template.layouts[active_layout].co)"
                                                        class="param-span">{{
                                                            getContentColor(template.layouts[active_layout].co)
                                                        }}</span></label>
                                                    <input type="color" v-model="template.layouts[active_layout].co">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <fg-input class="mt25" type="text"
                                              label="Ширина фрейма в Figma"
                                              v-model="template.layouts[active_layout].rawData.original_w"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Ширина редактируемой области"
                                              v-model="template.layouts[active_layout].rawData.w"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Высота редактируемой области"
                                              v-model="template.layouts[active_layout].rawData.h"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Отступ сверху"
                                              v-model="template.layouts[active_layout].rawData.y"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Отступ слева"
                                              v-model="template.layouts[active_layout].rawData.x"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Радиус верхний левый"
                                              v-model="template.layouts[active_layout].rawData.b_tl"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Радиус верхний правый"
                                              v-model="template.layouts[active_layout].rawData.b_tr"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Радиус нижний правый"
                                              v-model="template.layouts[active_layout].rawData.b_br"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Радиус нижний правый"
                                              v-model="template.layouts[active_layout].rawData.b_bl"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Поворот объекта (градусы)"
                                              v-model="template.layouts[active_layout].angle"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Тип layout</label>
                                        <select v-model="template.layouts[active_layout].layout_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="f in layout_types" v-bind:value="f.id">{{ f.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Эффект</label>
                                        <select v-model="template.layouts[active_layout].effect"
                                                id="layout-effect-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option :value="''">-</option>
                                            <option v-for="se in server_effects" v-bind:value="se.name">
                                                {{ se.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <label v-if="template.layouts[active_layout].effect" class="control-label">Интенсивность эффекта: <span
                                        class="param-span">{{ template.layouts[active_layout].effect_intensity }}</span></label>
                                    <fg-input type="range" v-if="template.layouts[active_layout].effect"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.layouts[active_layout].effect_intensity"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Фильтр</label>
                                        <select v-model="template.layouts[active_layout].filter"
                                                id="layout-filter-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option :value="''">-</option>
                                            <option v-for="sf in server_filters" v-bind:value="sf.name">
                                                {{ sf.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <label v-if="template.layouts[active_layout].filter" class="control-label">Интенсивность фильтра: <span
                                        class="param-span">{{ template.layouts[active_layout].filter_intensity }}</span></label>
                                    <fg-input type="range" v-if="template.layouts[active_layout].filter"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.layouts[active_layout].filter_intensity"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Размер обводки: <span
                                        class="param-span">{{ template.layouts[active_layout].stroke_size }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.layouts[active_layout].stroke_size"
                                              placeholder="">
                                    </fg-input>
                                    <label for="stroke-color">Цвет обводки:</label>
                                    <input type="color" id="stroke-color"
                                           v-model="template.layouts[active_layout].stroke_color">
                                    <fg-input type="text"
                                              label=""
                                              v-model="template.layouts[active_layout].stroke_color"
                                              placeholder="">
                                    </fg-input>

                                    <div class="clearfix"></div>
                                    <button type="button" class="btn btn-remove"
                                            @click="removeLayout(active_layout)">Удалить layout
                                    </button>


                                </div>
<!--{{ 22222 }}-->

                                <div class="col-md-3 c-labels" v-if="active_type === 'frame' && template && template.frames[active_frame]">
                                    <button type="button" class="btn btn-text btn-fill active control-btn"
                                            @click="changeFrame()">Заменить
                                    </button>
                                    <div class="clearfix"></div>
                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.frames[active_frame].alpha }}</span></label>

                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.frames[active_frame].alpha"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.frames[active_frame].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Ширина слайда в Figma"
                                              v-model="template.frames[active_frame].rawData.original_w"
                                              @input="onFrameRawDataChange"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Ширина фрейма"
                                              v-model="template.frames[active_frame].rawData.w"
                                              @input="onFrameRawDataChange"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Отступ сверху"
                                              v-model="template.frames[active_frame].rawData.y"
                                              @input="onFrameRawDataChange"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Отступ слева"
                                              v-model="template.frames[active_frame].rawData.x"
                                              @input="onFrameRawDataChange"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Поворот объекта (градусы)"
                                              v-model="template.frames[active_frame].angle"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Src"
                                              v-model="template.frames[active_frame].src"
                                              placeholder="">
                                    </fg-input>


                                    <div class="clearfix"></div>
                                    <button type="button" class="btn btn-remove"
                                            @click="removeFrame(active_frame)">Удалить фрейм
                                    </button>


                                </div>

                                <div class="col-md-3 c-labels" v-if="active_type === 'text' && template && template.texts.length > 0">
                                    <label class="control-label">Текст</label>
                                    <textarea class="text-area"
                                              v-model="template.texts[active_text].text">
                                    </textarea>

                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.texts[active_text].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].alpha"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.texts[active_text].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <img class="widget-icon" :src="`/static/img/widget${template.texts[active_text].type}.png`" v-if="template.texts[active_text].type"/>
                                    <div class="form-group" v-if="template.texts[active_text].type">
                                        <label class="control-label">Тип виджета</label>
                                        <select v-model="template.texts[active_text].type"
                                                id="category-control"
                                                @change="changeWidgetType(active_text, template.texts[active_text].type)"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="f in widget_types" v-bind:value="f.id">{{ f.name }}</option>
                                        </select>
                                    </div>

                                    <label class="control-label">Размер шрифта: <span
                                        class="param-span">{{ template.texts[active_text].font_size }}</span></label>
                                    <fg-input type="range"
                                              min="5" max="200" step="1"
                                              label=""
                                              v-model="template.texts[active_text].font_size"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Шрифт</label>
                                        <select v-model="template.texts[active_text].font_name"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="f in sortedFonts" v-bind:value="f.name">{{ f.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="control1" class="control-label label-checkbox">По центру по
                                            горизонтали</label>
                                        <input @change="setTextPosition(0.5, null)"
                                               :checked="template.texts[active_text].position_x == 0.5"
                                               id="control1" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position X"
                                                  @input="val => setTextPosition(val, null)"
                                                  v-model="template.texts[active_text].position_x"
                                                  placeholder="">
                                        </fg-input>
                                        <div class="clearfix"></div>
                                        <label for="control2" class="control-label label-checkbox">По центру по
                                            вертикали</label>
                                        <input @change="setTextPosition(null, 0.5)"
                                               :checked="template.texts[active_text].position_y == 0.5"
                                               id="control2" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position Y"
                                                  @input="val => setTextPosition(null, val)"
                                                  v-model="template.texts[active_text].position_y"
                                                  placeholder="">
                                        </fg-input>
                                    </div>

                                    <div class="form-group">
                                        <label for="control1" class="control-label label-checkbox mb10">Text brush</label>
                                        <input v-model="template.texts[active_text].is_text_brush"
                                               id="control1" class="form-check-inline"
                                               type="checkbox">
                                        <div class="clearfix"></div>
                                        <label class="control-label" v-if="template.texts[active_text].is_text_brush">Text brush data</label>
                                        <textarea class="text-area" v-if="template.texts[active_text].is_text_brush"
                                                  v-model="template.texts[active_text].text_brush_data">
                                    </textarea>
                                    </div>
                                    <fg-input type="text"
                                              label="Поворот текста (градусы)"
                                              v-model="template.texts[active_text].angle"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Межбуквенный интервал"
                                              v-model="template.texts[active_text].letter_spacing"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Межстрочный интервал"
                                              v-model="template.texts[active_text].line_spacing"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Цвет текста: <span class="param-span">{{
                                                template.texts[active_text].text_color
                                            }}</span></label>
                                        <input type="color" v-model="template.texts[active_text].text_color">
                                        <fg-input type="text"
                                                  label=""
                                                  v-model="template.texts[active_text].text_color"
                                                  placeholder="">
                                        </fg-input>
                                        <div class="color-set">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.texts[active_text].text_color}"
                                                  @click="setColor(c, 'color')"></span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Цвет фона:
                                            <span class="param-span"
                                                  v-if="template.texts[active_text].background_color === 'transparent'">Прозрачный</span>
                                            <span class="param-span"
                                                  v-else>{{ template.texts[active_text].background_color }}</span>
                                        </label>
                                        <input type="color" v-model="template.texts[active_text].background_color"
                                               v-show="template.texts[active_text].background_color !== 'transparent'">
                                        <fg-input type="text"
                                                  label=""
                                                  v-show="template.texts[active_text].background_color !== 'transparent'"
                                                  v-model="template.texts[active_text].background_color"
                                                  placeholder="">
                                        </fg-input>
                                        <div class="clearfix"></div>
                                        <label for="background-control" class="control-label label-checkbox mb10">Прозрачный</label>
                                        <input @change="toggleBackground()"
                                               :checked="template.texts[active_text].background_color === 'transparent'"
                                               id="background-control" class="form-check-inline"
                                               type="checkbox">
                                        <div class="color-set"
                                             v-show="template.texts[active_text].background_color !== 'transparent'">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.texts[active_text].background_color}"
                                                  @click="setColor(c, 'background')"></span>
                                        </div>
                                    </div>
                                    <label class="control-label">Прозрачность фона: <span
                                        class="param-span">{{ template.texts[active_text].bg_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].bg_alpha"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Направление текста</label>
                                        <select v-model="template.texts[active_text].direction"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="normal">normal</option>
                                            <option value="vertical">vertical</option>
                                            <option value="round">round</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Анимация</label>
                                        <select v-model="template.texts[active_text].animation_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="t in animation_types" v-bind:value="t.id">{{
                                                    t.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label v-show="template.texts[active_text].animation_type !== 0"
                                           class="control-label">Длительность анимации: <span
                                        class="param-span">{{
                                            template.texts[active_text].animation_duration
                                        }}</span></label>
                                    <fg-input v-show="template.texts[active_text].animation_type !== 0" type="range"
                                              min="0" max="20" step="0.1"
                                              label=""
                                              v-model="template.texts[active_text].animation_duration"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Выравнивание <br>(если больше одной строки)</label>
                                        <select v-model="template.texts[active_text].text_align"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="ta in text_aligns" v-bind:value="ta.name">{{
                                                    ta.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label for="shadow-color">Цвет тени:</label>
                                    <input type="color" id="shadow-color"
                                           v-model="template.texts[active_text].shadow_color">
                                    <fg-input type="text"
                                              label=""
                                              v-model="template.texts[active_text].shadow_color"
                                              placeholder="">
                                    </fg-input>
                                    <div class="clearfix"></div>
                                    <label class="control-label">Радиус размытия тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_blur }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].shadow_blur"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Сдвиг тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_distance }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].shadow_distance"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Видимость тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].shadow_alpha"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Размер обводки: <span
                                        class="param-span">{{ template.texts[active_text].stroke_size }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].stroke_size"
                                              placeholder="">
                                    </fg-input>
                                    <label for="stroke-color">Цвет обводки:</label>
                                    <input type="color" id="stroke-color"
                                           v-model="template.texts[active_text].stroke_color">
                                    <fg-input type="text"
                                              label=""
                                              v-model="template.texts[active_text].stroke_color"
                                              placeholder="">
                                    </fg-input>
                                    <div class="clearfix"></div>

                                    <button type="button" class="btn btn-remove"
                                            @click="removeText(active_text)">Удалить текст
                                    </button>
                                    <div class="clearfix"></div>

                                </div>


                                <div class="col-md-3 c-labels" v-if="active_type === 'object' && template && template.objects.length > 0">
                                    <button type="button" class="btn btn-text btn-fill active control-btn"
                                            @click="changeObject()">Заменить
                                    </button>
                                    <div class="clearfix"></div>
                                    <label class="control-label">Объект</label>
                                    <img alt="" @click="changeObject()" class="object-preview"
                                         :src="objectPlayerSrc(template.objects[active_object])">

                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.objects[active_object].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.objects[active_object].alpha"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.objects[active_object].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Размер:"
                                              v-model="template.objects[active_object].scale"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="range"
                                              min="0.03" max="5" step="0.0001"
                                              label=""
                                              v-model="template.objects[active_object].scale"
                                              placeholder="">
                                    </fg-input>

                                    <div class="form-group">
                                        <label for="control3" class="control-label label-checkbox mb10">По центру по
                                            горизонтали</label>
                                        <input @change="setObjectPosition(0.5, null)"
                                               :checked="template.objects[active_object].position_x == 0.5"
                                               id="control3" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position X"
                                                  @input="val => setObjectPosition(val, null)"
                                                  v-model="template.objects[active_object].position_x"
                                                  placeholder="">
                                        </fg-input>
                                        <div class="clearfix"></div>
                                        <label for="control4" class="control-label label-checkbox mb10">По центру по
                                            вертикали</label>
                                        <input @change="setObjectPosition(null, 0.5)"
                                               :checked="template.objects[active_object].position_y == 0.5"
                                               id="control4" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position Y"
                                                  @input="val => setObjectPosition(null, val)"
                                                  v-model="template.objects[active_object].position_y"
                                                  placeholder="">
                                        </fg-input>
                                    </div>

                                    <fg-input type="text"
                                              label="Поворот объекта (градусы)"
                                              v-model="template.objects[active_object].angle"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group"
                                         v-show="template.objects[active_object].id.indexOf('nocolor') < 0 && !isGifSrc(template.objects[active_object].id)">
                                        <label class="control-label">Цвет: <span class="param-span">{{
                                                template.objects[active_object].color
                                            }}</span></label>
                                        <input type="color" v-model="template.objects[active_object].color">
                                        <fg-input type="text"
                                                  label=""
                                                  v-model="template.objects[active_object].color"
                                                  placeholder="">
                                        </fg-input>
                                        <div class="color-set">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.objects[active_object].color}"
                                                  @click="setObjColor(c)"></span>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="control-label">Анимация</label>
                                        <select v-model="template.objects[active_object].animation_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="t in animation_types" v-bind:value="t.id">{{
                                                    t.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label v-show="template.objects[active_object].animation_type !== 0"
                                           class="control-label">Длительность анимации: <span
                                        class="param-span">{{
                                            template.objects[active_object].animation_duration
                                        }}</span></label>
                                    <fg-input v-show="template.objects[active_object].animation_type !== 0" type="range"
                                              min="0" max="20" step="0.1"
                                              label=""
                                              v-model="template.objects[active_object].animation_duration"
                                              placeholder="">
                                    </fg-input>

                                    <label for="shadow-color">Цвет тени:</label>
                                    <input type="color" id="shadow-color"
                                           v-model="template.objects[active_object].shadow_color">
                                    <fg-input type="text"
                                              label=""
                                              v-model="template.objects[active_object].shadow_color"
                                              placeholder="">
                                    </fg-input>
                                    <div class="clearfix"></div>
                                    <label class="control-label">Радиус размытия тени: <span
                                        class="param-span">{{ template.objects[active_object].shadow_blur }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.objects[active_object].shadow_blur"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Сдвиг тени: <span
                                        class="param-span">{{ template.objects[active_object].shadow_distance }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.objects[active_object].shadow_distance"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Видимость тени: <span
                                        class="param-span">{{ template.objects[active_object].shadow_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.objects[active_object].shadow_alpha"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Src"
                                              v-model="template.objects[active_object].id"
                                              placeholder="">
                                    </fg-input>

                                    <button type="button" class="btn btn-remove"
                                            @click="removeObject(active_object)">Удалить объект
                                    </button>
                                    <div class="clearfix"></div>

                                </div>

                                <div class="col-md-7">
                                    <div id="preview-container" class="preview-sticky" :style="{ top: layersBarHeight + 'px' }" v-if="template">

                                        <div id="preview-previous"
                                             :style="{ height: heightCanvas + 'px' }">
                                            <div class="preview-media"
                                                 :style="{ backgroundImage: 'url(' + template.src_full + ')' }"></div>
                                        </div>
                                        <div id="preview"
                                             :style="{ height: heightCanvas + 'px' }"
                                             v-show="template.src_full">
                                            <div class="preview-media"
                                                 :style="{ backgroundImage: 'url(' + template.src_full + ')' }"></div>

                                            <div v-for="(la, index) in template.layouts"
                                                 v-if="la.rawData.w && la.rawData.h && la.rawData.original_w"
                                                 v-bind:id="`l${index}`">
                                                <div class="layout-div"
                                                    v-html="layout_html(index)" @click="selectLayout(index)">
                                                </div>
                                            </div>
                                            <div v-for="(tt, index) in template.texts"
                                                 ref="draggableContainer" class="draggable-container"
                                                 v-if="tt.font_size"
                                                 v-bind:id="`${index}`"
                                                 :style="{ zIndex: tt.z_index }">
                                                <div v-show="tt.is_visible === 1" class="draggable-header" v-if="fonts.length > 1"
                                                     :class="{ active: index === active_text && active_type === 'text' }"
                                                     v-html="text_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                            <div v-for="(tt, index) in template.objects"
                                                 ref="draggableContainer2" class="draggable-container" v-if="tt.scale"
                                                 v-bind:id="`o${index}`"
                                                 :style="{ zIndex: tt.z_index }">
                                                <div v-if="tt.id.indexOf('.svg') > 0" v-show="tt.is_visible === 1" class="draggable-header nospace"
                                                     :class="{ active: index === active_object && active_type === 'object' }"
                                                     v-html="object_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                                <div v-if="tt.id.indexOf('.svg') < 0" v-show="tt.is_visible === 1" class="draggable-header nospace"
                                                     :class="{ active: index === active_object && active_type === 'object' }"
                                                     v-html="image_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                            <div v-for="(fr, index) in template.frames"
                                                 ref="draggableContainer3" class="draggable-container"
                                                 v-if="fr.layouts"
                                                 v-bind:id="`f${index}`"
                                                 :style="{ zIndex: fr.z_index }">
                                                <div class="draggable-header nospace"
                                                     :class="{ active: index === active_frame && active_type === 'frame' }"
                                                     v-html="frame_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>

                                        </div>
<!--                                        <div id="preview-next"-->
<!--                                             :style="{ height: heightCanvas + 'px',-->
<!--                                              backgroundImage: 'url(' + template.src_full + ')'}">-->
<!--                                        </div>-->

                                        <button type="button" class="btn-layout-highlight"
                                                :class="{ 'active-state': show_layout_highlight }"
                                                title="Отключение видимости лэйаутов в редакторе"
                                                @click.prevent="toggleLayoutHighlight">
                                            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                                                <rect class="layer-fill" x="3" y="6" width="12" height="12" rx="2" fill="currentColor" opacity="0.28"/>
                                                <rect class="layer-fill" x="9" y="3" width="12" height="12" rx="2" fill="currentColor" opacity="0.5"/>
                                                <rect x="3" y="6" width="12" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.4"/>
                                                <rect x="9" y="3" width="12" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.4"/>
                                                <rect x="6" y="9" width="12" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.4"/>
                                            </svg>
                                        </button>
                                    </div>

                                </div>


                            </div>

                            <div class="clearfix"></div>
                        </form>
                    </card>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const _ = require('lodash')

const moment = require('moment')
import Card from 'src/components/UIComponents/Cards/Card.vue'
import {template} from "lodash";
import {du} from "@fullcalendar/core/internal-common";
import graphics from "../Graphics.vue";
import unsavedLeaveGuard from 'src/mixins/unsavedLeaveGuard'
import replaceGraphicSize from 'src/mixins/replaceGraphicSize'
import gifGraphic from 'src/mixins/gifGraphic'
import stickyLayers from 'src/mixins/stickyLayers'

export default {
    name: 'EditCategory',
    mixins: [unsavedLeaveGuard, replaceGraphicSize, gifGraphic, stickyLayers],
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            post: null,
            parts: [],
            activeVideo: '',
            waiting: false,
            textWaiting: false,
            interval: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            show_collage_modal: false,
            show_frames_modal: false,
            is_object_changing: false,
            is_frame_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('posts_categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_layout: 0,
            show_layout_highlight: true,
            active_text: 0,
            active_object: 0,
            active_frame: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            realVideoDuration: null,
            realAudioDuration: null,
            effect: "",
            effect_intensity: 100,
            filter: "",
            filter_intensity: 100,
            copiedPartId: null,
            heightCanvas: 450,
            active_object_category: 'Arrows',
            active_frame_category: 1,
            active_collage_category: '2',
            previous_collage_id: null,
            active_part_index: null,
            tags: [],
            server_effects: [],
            server_graphics: [],
            server_filters: [],
            server_fonts: [],
            server_frames: [],
            svg_sources: [],
            default_part: {
                src: null,
                src_full: '/static/img/part_placeholder.jpg',
                src_size: 0,
                video_src: null,
                video_src_full: null,
                video_src_size: 0,
                video_preview: false,
                n: 0,
                texts: [],
                objects: [],
                layouts: [],
                frames: []
            },
            default_layout: {
                is_content: false,
                co: null,
                is_bg: false,
                angle: 0,
                alpha: 1,
                z_index: 0,
                layout_type: 1,
                effect: "",
                effect_intensity: 100,
                filter: "",
                filter_intensity: 100,
                stroke_size: 0,
                stroke_color: '#000000',
                rawData: {
                    original_w: 1080,
                    w: 1080,
                    h: 1350,
                    x: 0,
                    y: 0,
                    b_tl: 0,
                    b_tr: 0,
                    b_br: 0,
                    b_bl: 0,
                },
                data: {}
            },
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#000000",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                bg_alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                is_text_brush: 0,
                text_brush_data: [],
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                shadow_color: '#000000',
                shadow_alpha: 0.16,
                shadow_distance: 0,
                shadow_blur: 10,
                animation_type: 0,
                animation_duration: 0,
                stroke_size: 0,
                stroke_color: '#000000',
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                shadow_color: '#000000',
                shadow_alpha: 0,
                shadow_distance: 0,
                shadow_blur: 0,
            },
            texts: [],
            objects: [],
            colors: [
                "#FFFFFF",
                "#000000",
                "#F9F7F4",
                "#FAF5ED",
                "#F2E8DD",
                "#F4E4DD",
                "#D9BEBD",
                "#C5AEB6",
                "#E3C2D2",
                "#F1E0EF",
                "#D5C9E9",
                "#C8ACE0",
                "#E06E97",
                "#E64F3C",
                "#AB613E",
                "#B97959",
                "#D99056",
                "#E8BF88",
                "#EDD8AB",
                "#FAE389",
                "#F5C154",
                "#B78C3A",
                "#585B3B",
                "#7B7C41",
                "#BBB595",
                "#DFE7DA",
                "#C0DED3",
                "#B4C5C9",
                "#C9D9F0",
                "#4E63EC",
                "#4F5E8D",
                "#725B6E",
                "#F0F0F0",
                "#D9D9D9",
                "#616161",
                "#3C3C3C",
            ],
            fonts: [
                {
                    params: "'SF Pro', sans-serif;",
                    code: "SF Pro",
                    name: "SF Pro",
                },
            ],
            animation_types: [
                {
                    id: 0,
                    name: "-",
                },
                {
                    id: 1,
                    name: "Fade",
                },
                {
                    id: 4,
                    name: "Scale",
                },
                {
                    id: 6,
                    name: "Reveal ↓",
                },
                {
                    id: 7,
                    name: "Reveal ↑",
                },
                {
                    id: 8,
                    name: "Reveal →",
                },
                {
                    id: 9,
                    name: "Reveal ←",
                },
                {
                    id: 10,
                    name: "Float ↓",
                },
                {
                    id: 11,
                    name: "Float ↑",
                },
                {
                    id: 12,
                    name: "Float →",
                },
                {
                    id: 13,
                    name: "Float ←",
                },
                {
                    id: 14,
                    name: "Typewriter",
                },
                {
                    id: 15,
                    name: "Typewriter Fade In",
                },
                {
                    id: 16,
                    name: "Typewriter By Word",
                },
            ],
            effect_types: [
                {
                    id: 0,
                    name: "-",
                },
                {
                    id: 1,
                    name: "Zoom in",
                },
                {
                    id: 2,
                    name: "Zoom out",
                },
                {
                    id: 3,
                    name: "Snow",
                },
                {
                    id: 4,
                    name: "VHS",
                },
            ],
            widget_types: [
                {
                    id: 1,
                    name: "Message (справа)",
                },
                {
                    id: 5,
                    name: "Message (слева)",
                },
                {
                    id: 2,
                    name: "Time",
                },
                {
                    id: 3,
                    name: "Location",
                },
                {
                    id: 4,
                    name: "Custom tag (снизу)",
                },
                {
                    id: 6,
                    name: "Custom tag (сверху)",
                },
                {
                    id: 7,
                    name: "Selection",
                },
            ],
            layout_types: [
                {
                    id: 1,
                    name: "Обычный",
                },
                {
                    id: 2,
                    name: "Overlay",
                },
                {
                    id: 3,
                    name: "Overlay + Удаленный фон",
                },
            ],
            collage_types: [
                {
                    id: 0,
                    name: "-",
                    params: null,
                },
                {
                    id: 1,
                    name: "1/4",
                    params: {x: 0, y: 0, w: 0.5, h: 0.5},
                },
                {
                    id: 2,
                    name: "2/4",
                    params: {x: 0.5, y: 0, w: 0.5, h: 0.5},
                },
                {
                    id: 3,
                    name: "3/4",
                    params: {x: 0, y: 0.5, w: 0.5, h: 0.5},
                },
                {
                    id: 4,
                    name: "4/4",
                    params: {x: 0.5, y: 0.5, w: 0.5, h: 0.5},
                },
                {
                    id: 5,
                    name: "1/3",
                    params: {x: 0, y: 0, w: 1, h: 0.3333},
                },
                {
                    id: 6,
                    name: "2/3",
                    params: {x: 0, y: 0.3333, w: 1, h: 0.3333}
                },
                {
                    id: 7,
                    name: "3/3",
                    params: {x: 0, y: 0.6666, w: 1, h: 0.3333}
                },
                {
                    id: 8,
                    name: "1/2",
                    params: {x: 0, y: 0, w: 1, h: 0.5}
                },
                {
                    id: 9,
                    name: "2/2",
                    params: {x: 0, y: 0.5, w: 1, h: 0.5}
                },
                {
                    id: 10,
                    name: "1/6",
                    params: {x: 0, y: 0, w: 0.5, h: 0.3333},
                },
                {
                    id: 11,
                    name: "2/6",
                    params: {x: 0.5, y: 0, w: 0.5, h: 0.3333},
                },
                {
                    id: 12,
                    name: "3/6",
                    params: {x: 0, y: 0.3333, w: 0.5, h: 0.3333},
                },
                {
                    id: 13,
                    name: "4/6",
                    params: {x: 0.5, y: 0.3333, w: 0.5, h: 0.3333},
                },
                {
                    id: 14,
                    name: "5/6",
                    params: {x: 0, y: 0.6666, w: 0.5, h: 0.3333},
                },
                {
                    id: 15,
                    name: "6/6",
                    params: {x: 0.5, y: 0.6666, w: 0.5, h: 0.3333},
                },
            ],
            content_types: [
                {
                    id: 0,
                    name: "Обычный",
                },
                {
                    id: 1,
                    name: "Статика",
                },
                {
                    id: 2,
                    name: "Цвет",
                },
            ],
            text_aligns: [
                {
                    name: "center",
                },
                {
                    name: "start",
                },
                {
                    name: "end",
                },

            ],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: [],
            frame_positions: [],
            collages: [
                {
                    name: '2',
                    data: [
                        {
                            id: '2_1',
                            frames: [
                                { x: 0, y: 0, width: 1.0, height: 0.5 },
                                { x: 0, y: 0.5, width: 1.0, height: 0.5 },
                            ],
                        },
                        {
                            id: '2_2',
                            frames: [
                                { x: 0, y: 0, width: 1.0, height: 0.491 },
                                { x: 0, y: 0.509, width: 1.0, height: 0.491 },
                            ],
                        },
                        {
                            id: '2_3',
                            frames: [
                                { x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474 },
                                { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474 },
                            ],
                        },
                        {
                            id: '2_4',
                            frames: [
                                { x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '2_5',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 1.0 },
                                { x: 0.5, y: 0, width: 0.5, height: 1.0 },
                            ],
                        },
                        {
                            id: '2_6',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.315 },
                                { x: 0, y: 0.315, width: 1, height: 0.685 },
                            ],
                        },
                        {
                            id: '2_7',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.685 },
                                { x: 0, y: 0.685, width: 1, height: 0.315 },
                            ],
                        },
                        {
                            id: '2_8',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0.5, width: 0.5, height: 0.5 },
                            ],
                        },
                        {
                            id: '2_9',
                            frames: [
                                { x: 0.2375, y: 0.1223, width: 0.532, height: 0.3647 },
                                { x: 0.2375, y: 0.5133, width: 0.532, height: 0.3647 },
                            ],
                        },
                    ],
                },
                {
                    name: '3',
                    data: [
                        {
                            id: "3_1",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.3333},
                                {x: 0, y: 0.3333, width: 1, height: 0.3334},
                                {x: 0, y: 0.6667, width: 1, height: 0.3333},
                            ],
                        },
                        {
                            id: "3_2",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.326783},
                                {x: 0, y: 0.336758, width: 1, height: 0.326783},
                                {x: 0, y: 0.673216, width: 1, height: 0.326783},
                            ],
                        },
                        {
                            id: "3_3",
                            frames: [
                                {x: 0.028, y: 0.015625, width: 0.944, height: 0.3125},
                                {x: 0.028, y: 0.34375, width: 0.944, height: 0.3125},
                                {x: 0.028, y: 0.671875, width: 0.944, height: 0.3125},
                            ],
                        },
                        {
                            id: "3_4",
                            frames: [
                                {
                                    x: 0.028,
                                    y: 0.015625,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                                {
                                    x: 0.028,
                                    y: 0.34375,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                                {
                                    x: 0.028,
                                    y: 0.671875,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                            ],
                        },
                        {
                            id: "3_5",
                            frames: [
                                {x: 0, y: 0, width: 0.5, height: 0.3333},
                                {x: 0.5, y: 0.3333, width: 0.5, height: 0.3333},
                                {x: 0, y: 0.6667, width: 0.5, height: 0.3333},
                            ],
                        },
                        {
                            id: "3_6",
                            frames: [
                                {x: 0, y: 0, width: 0.3333, height: 1},
                                {x: 0.3333, y: 0, width: 0.3333, height: 1},
                                {x: 0.6667, y: 0, width: 0.3333, height: 1},
                            ],
                        },
                        {
                            id: "3_7",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.5},
                                {x: 0, y: 0.5, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0.5, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_8",
                            frames: [
                                {x: 0, y: 0.5, width: 1, height: 0.5},
                                {x: 0, y: 0, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_9",
                            frames: [
                                {x: 0, y: 0, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0, width: 0.5, height: 0.5},
                                {x: 0, y: 0.5, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_10",
                            frames: [
                                {x: 0.0648, y: 0.064, width: 0.4815, height: 0.28125},
                                {x: 0.0648, y: 0.35925, width: 0.4815, height: 0.28125},
                                {x: 0.0648, y: 0.6564, width: 0.4815, height: 0.28125},
                            ],
                        },
                    ]
                },
                {
                    name: '4',
                    data: [
                        {
                            id: "4_1",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.25 },
                                { x: 0, y: 0.25, width: 1, height: 0.25 },
                                { x: 0, y: 0.5, width: 1, height: 0.25 },
                                { x: 0, y: 0.75, width: 1, height: 0.25 },
                            ],
                        },
                        {
                            id: "4_2",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.24267 },
                                { x: 0, y: 0.25264333, width: 1, height: 0.24267 },
                                { x: 0, y: 0.50498666, width: 1, height: 0.24267 },
                                { x: 0, y: 0.75733, width: 1, height: 0.24267 },
                            ],
                        },
                        {
                            id: "4_3",
                            frames: [
                                { x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875 },
                            ],
                        },
                        {
                            id: "4_4",
                            frames: [
                                { x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                            ],
                        },
                        {
                            id: "4_5",
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0.5, width: 0.5, height: 0.5 },
                            ],
                        },
                        {
                            id: "4_6",
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.4948 },
                                { x: 0.50925, y: 0, width: 0.49075, height: 0.4948 },
                                { x: 0, y: 0.5052, width: 0.49075, height: 0.4948 },
                                { x: 0.50925, y: 0.5052, width: 0.49075, height: 0.4948 },
                            ],
                        },
                        {
                            id: "4_7",
                            frames: [
                                { x: 0.0315, y: 0.017708, width: 0.45925, height: 0.410417 },
                                { x: 0.50925, y: 0.017708, width: 0.45927, height: 0.410417 },
                                { x: 0.0315, y: 0.438542, width: 0.45927, height: 0.410417 },
                                { x: 0.50925, y: 0.438542, width: 0.45927, height: 0.410417 },
                            ],
                        },
                        {
                            id: "4_8",
                            frames: [
                                { x: 0.0407, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.5213, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.0407, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.5213, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                            ],
                        },
                        {
                            id: "4_9",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 },
                            ],
                        },
                        {
                            id: "4_10",
                            frames: [
                                { x: 0.01852, y: 0.010717, width: 0.96296, height: 0.48381425 },
                                { x: 0.01852, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                                { x: 0.34568, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                                { x: 0.67284, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                            ],
                        },
                        {
                            id: "4_11",
                            frames: [
                                { x: 0.01852, y: 0.010417, width: 0.400926, height: 0.4843745 },
                                { x: 0.437966, y: 0.010417, width: 0.543514, height: 0.4843745 },
                                { x: 0.01852, y: 0.5052085, width: 0.543514, height: 0.4843745 },
                                { x: 0.580554, y: 0.5052085, width: 0.400926, height: 0.4843745 },
                            ],
                        },
                        {
                            id: "4_12",
                            frames: [
                                { x: 0, y: 0, width: 0.49074, height: 0.4895829967 },
                                { x: 0.50926, y: 0, width: 0.49074, height: 0.4895829967 },
                                { x: 0, y: 0.4999996633, width: 1, height: 0.2447917 },
                                { x: 0, y: 0.7552083, width: 1, height: 0.2447917 },
                            ],
                        },
                    ]
                },
                {
                    name: '5',
                    data: [
                        {
                            id: '5_1',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.2 },
                                { x: 0, y: 0.2, width: 1, height: 0.2 },
                                { x: 0, y: 0.4, width: 1, height: 0.2 },
                                { x: 0, y: 0.6, width: 1, height: 0.2 },
                                { x: 0, y: 0.8, width: 1, height: 0.2 },
                            ],
                        },
                        {
                            id: '5_2',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.1875 },
                                { x: 0, y: 0.203125, width: 1, height: 0.1875 },
                                { x: 0, y: 0.40625, width: 1, height: 0.1875 },
                                { x: 0, y: 0.609375, width: 1, height: 0.1875 },
                                { x: 0, y: 0.8125, width: 1, height: 0.1875 },
                            ],
                        },
                        {
                            id: '5_3',
                            frames: [
                                { x: 0.028, y: 0.015825, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095 },
                            ],
                        },
                        {
                            id: '5_4',
                            frames: [
                                { x: 0.028, y: 0.015825, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '5_5',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 1, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.5, height: 0.3334 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_6',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 1 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 1 },
                            ],
                        },
                        {
                            id: '5_7',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 1, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 1, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_8',
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.4947915 },
                                { x: 0, y: 0.5052085, width: 0.49075, height: 0.4947915 },
                                { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.33710567, width: 0.49075, height: 0.32608867 },
                                { x: 0.50927, y: 0.67361134, width: 0.49075, height: 0.32638867 },
                            ],
                        },
                        {
                            id: '5_9',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_11',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 },
                            ],
                        },
                    ],
                },
                {
                    name: '6',
                    data: [
                        {
                            id: '6_1',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.16697 },
                                { x: 0, y: 0.16637, width: 1, height: 0.16697 },
                                { x: 0, y: 0.33304, width: 1, height: 0.16697 },
                                { x: 0, y: 0.49971, width: 1, height: 0.16697 },
                                { x: 0, y: 0.66638, width: 1, height: 0.16696 },
                                { x: 0, y: 0.83304, width: 1, height: 0.16696 },
                            ],
                        },
                        {
                            id: '6_2',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.16790283, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.33680566, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.50520849, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.67361132, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.84201415, width: 1, height: 0.15798583 },
                            ],
                        },
                        {
                            id: '6_3',
                            frames: [
                                { x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152 },
                            ],
                        },
                        {
                            id: '6_4',
                            frames: [
                                { x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '6_14',
                            frames: [
                                { x: 0, y: 0, width: 0.1667, height: 1 },
                                { x: 0.1667, y: 0, width: 0.1666, height: 1 },
                                { x: 0.3333, y: 0, width: 0.1667, height: 1 },
                                { x: 0.5, y: 0, width: 0.1667, height: 1 },
                                { x: 0.6667, y: 0, width: 0.1666, height: 1 },
                                { x: 0.8333, y: 0, width: 0.1667, height: 1 },
                            ],
                        },
                        {
                            id: '6_5',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_6',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.5, height: 0.3334 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_7',
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0, y: 0.33685567, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.33685567, width: 0.49075, height: 0.32638867 },
                                { x: 0, y: 0.67321134, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.67321134, width: 0.49075, height: 0.32638867 },
                            ],
                        },
                        {
                            id: '6_8',
                            frames: [
                                { x: 0, y: 0, width: 0.369444, height: 0.25 },
                                { x: 0, y: 0.25, width: 0.369444, height: 0.25 },
                                { x: 0.369444, y: 0, width: 0.630556, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.630556, height: 0.5 },
                                { x: 0.630556, y: 0.5, width: 0.369444, height: 0.25 },
                                { x: 0.630556, y: 0.75, width: 0.369444, height: 0.25 },
                            ],
                        },
                        {
                            id: '6_9',
                            frames: [
                                { x: 0, y: 0, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.2526175, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.505235, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.7578525, width: 0.369444, height: 0.2421475 },
                                { x: 0.387964, y: 0, width: 0.612036, height: 0.4947915 },
                                { x: 0.387964, y: 0.505235, width: 0.612036, height: 0.4947915 },
                            ],
                        },
                        {
                            id: '6_10',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.65833 },
                                { x: 0, y: 0.65833, width: 0.3333, height: 0.34167 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.34167 },
                                { x: 0.3333, y: 0.34167, width: 0.3333, height: 0.65833 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 0.65833 },
                                { x: 0.6666, y: 0.65833, width: 0.3334, height: 0.34167 },
                            ],
                        },
                        {
                            id: '6_11',
                            frames: [
                                { x: 0, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0.33950667, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0.67851334, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0, y: 0.33685867, width: 0.32098667, height: 0.32638867 },
                                { x: 0, y: 0.67321734, width: 0.32098667, height: 0.32638867 },
                                { x: 0.33950667, y: 0.33685867, width: 0.66049333, height: 0.66314133 },
                            ],
                        },
                        {
                            id: '6_12',
                            frames: [
                                { x: 0, y: 0, width: 0.68611, height: 0.3333 },
                                { x: 0.68611, y: 0, width: 0.31389, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.31389, height: 0.3333 },
                                { x: 0.31389, y: 0.3333, width: 0.68611, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.68611, height: 0.3334 },
                                { x: 0.68611, y: 0.6666, width: 0.31389, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_13',
                            frames: [
                                { x: 0.084185, y: 0.14375, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.14375, width: 0.391667, height: 0.22013867 },
                                { x: 0.084185, y: 0.38993067, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.38993067, width: 0.391667, height: 0.22013867 },
                                { x: 0.084185, y: 0.63611134, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.63611134, width: 0.391667, height: 0.22013867 },
                            ],
                        },
                    ],
                }
            ],
        }
    },
    watch: {

    },
    created: function () {
        let self = this;
        self.id = this.$route.params.id;

        self.getResources();
        self._nudgeKeydownHandler = self.onNudgeKeydown.bind(self);
        document.addEventListener('keydown', self._nudgeKeydownHandler, true);
    },
    beforeDestroy: function () {
        document.removeEventListener('keydown', this._nudgeKeydownHandler, true);
    },
    computed: {
        graphicsUrl() {
            return this.$graphicsUrl
        },
        framesUrl() {
            return this.$framesUrl
        },
        fontsUrl() {
            return this.$fontsUrl
        },
        previewSlideHeight() {
            return Math.round(92 * this.heightCanvas / 360);
        },
        sortedFonts() {
            return _.sortBy(this.fonts, (f) => {
                return f.name;
            });
        },
        versions() {
            const result = []
            const start = 101
            const end = start + 19

            for (let i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1))
            }

            return result
        },
        nolaVersions() {
            const result = []
            const start = 11
            const end = start + 19

            for (let i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1))
            }

            return result
        },
        calculatedMediaCount() {
            const parts = this.post && this.post.parts ? this.post.parts : [];
            let count = 0;

            for (let i = 0; i < parts.length; i++) {
                const part = parts[i] || {};
                count += Array.isArray(part.layouts) ? part.layouts.length : 0;

                const frames = Array.isArray(part.frames) ? part.frames : [];
                for (let j = 0; j < frames.length; j++) {
                    const frame = frames[j] || {};
                    count += Array.isArray(frame.layouts) ? frame.layouts.length : 0;
                }
            }

            return count;
        },
    },
    methods: {
        openResource: function(url) {
            window.open(url, "_blank");
        },
        text_html(index) {
            let textModel = this.template.texts[index];

            let text = _.find(this.fonts, (f) => f.name === textModel.font_name);
            if (!text) {
               // alert('Шрифт ' + textModel.font_name + ' не найден. Пожалуйста, замените на другой.');

                text = _.first(this.fonts);
            }

            let line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            let alpha = textModel.alpha;

            let bgColor = textModel.background_color

            if (parseFloat(textModel.bg_alpha) < 0.99) {
                bgColor = textModel.background_color + `${textModel.bg_alpha * 100}`;
            }

            let direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' +
                    '  text-orientation: upright;\n'
            }

            let offset = 4 / 88 * textModel.font_size;
            let blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            let shadow = `text-shadow: ${offset}px ${offset}px ${blur}px ${textModel.shadow_color}${this.convertAlphaToHex(textModel.shadow_alpha)};`;

            return '<span style="color: ' + textModel.text_color + '; ' +
                'background-color: ' + bgColor + '; ' +
                'font-size: ' + textModel.font_size + 'px; ' +
                'letter-spacing: ' + textModel.letter_spacing + 'px; ' +
                'opacity: ' + alpha + '; ' +
                'line-height: ' + line_height + 'px; ' +
                'transform: rotate( ' + textModel.angle + 'deg); ' +
                'display: block;' +
                direction +
                shadow +
                'text-align: ' + textModel.text_align + '; ' +
                'z-index: ' + textModel.z_index + '; ' +
                'font-family:' + text.params + ';">'
                + textModel.text + '</span>';

        },
        object_html(index) {
            return this.renderSvgObjectHtml(this.template.objects[index]);
        },
        image_html(index) {
            let objectModel = this.template.objects[index];

            if (!objectModel.source || !objectModel.dimensions) {
                return "";
            }

            let width = objectModel.dimensions.width;
            let height = objectModel.dimensions.height;

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            let img = `<img src="${this.objectPlayerSrc(objectModel)}">`;

            let style = ` style="width: ${width}px; height: ${height}px; opacity: ${objectModel.alpha}; transform: rotate(${objectModel.angle}deg); z-index: ${objectModel.z_index}; display: block;"`;

            img = this.insertAt(img, style, 5)

            return img;
        },
        layout_html(index) {
            let layoutModel = this.template.layouts[index].rawData;
            let layout = this.template.layouts[index];

            let scale = 360 / parseFloat(layoutModel.original_w);

            let overlay = {
                w: layoutModel.w * scale,
                h: layoutModel.h * scale,
                x: layoutModel.x * scale,
                y: layoutModel.y * scale,
                b_tl: parseFloat(layoutModel.b_tl * scale).toFixed(2),
                b_tr: parseFloat(layoutModel.b_tr * scale).toFixed(2),
                b_br: parseFloat(layoutModel.b_br * scale).toFixed(2),
                b_bl: parseFloat(layoutModel.b_bl * scale).toFixed(2),
            }

            const colors = [
                'rgba(255, 0, 0, 0.4)',
                'rgba(0, 128, 0, 0.4)',
                'rgba(0, 0, 255, 0.4)',
                'rgba(255, 165, 0, 0.4)',
                'rgba(128, 0, 128, 0.4)',
                'rgba(0, 206, 209, 0.4)',
                'rgba(255, 192, 203, 0.4)',
                'rgba(255, 255, 0, 0.4)',
                'rgba(165, 42, 42, 0.4)',
                'rgba(128, 128, 128, 0.4)'
            ]

            let layoutDiv = `<div class="overlay ${ index === this.active_layout && this.active_type === 'layout' ? 'active' : '' }"></div>`;

            let background = this.show_layout_highlight
                ? `background: ${colors[index] ? colors[index] : colors[0]}`
                : 'background: transparent';

            if (layout.is_content && layout.co) {
                background = `background-image: url('${layout.co_full}'); background-size: cover;`
            }

            let style = ` style="${background}; top: ${overlay.y}px; left: ${overlay.x}px; width: ${overlay.w}px; height: ${overlay.h}px;
                border-radius: ${overlay.b_tl}px ${overlay.b_tr}px ${overlay.b_br}px ${overlay.b_bl}px; z-index: 0;
                opacity: ${layout.alpha}; padding: 0px; transform: rotate(${layout.angle}deg);"`;

            layoutDiv = this.insertAt(layoutDiv, style, 5)

            return layoutDiv;
        },
        frame_html(index) {
            let frameModel = this.template.frames[index];

            let scale = 360 / parseFloat(frameModel.rawData.original_w);

            let width = frameModel.rawData.w * scale;

            let img = `<img src="${this.framesUrl}${frameModel.src}">`;

            let style = ` style="width: ${width}px; opacity: ${frameModel.alpha}; padding: 0px; transform: rotate(${frameModel.angle}deg); z-index: ${frameModel.z_index}; display: block;"`;

            img = this.insertAt(img, style, 5)

            return img;
        },
        isVideo: function (url) {
            return url.indexOf('.mp4') > -1;
        },
        getUnsavedState() {
            return this.stringifyUnsaved({
                post: this.post,
                effect: this.effect,
                effect_intensity: this.effect_intensity,
                filter: this.filter,
                filter_intensity: this.filter_intensity
            })
        },
        isEmptyFilter(value) {
            return value == null || value === '' || value === '-';
        },
        normalizeLayoutFilter(layout) {
            let name = '';
            let intensity = 100;

            if (!this.isEmptyFilter(layout.filters)) {
                name = String(layout.filters).split(':')[0];
                intensity = String(layout.filters).split(':')[1] || 100;
            } else if (!this.isEmptyFilter(layout.filter)) {
                name = layout.filter;
                intensity = layout.filter_intensity || 100;
            }

            if (this.isEmptyFilter(name)) {
                layout.filter = '';
                layout.filter_intensity = 100;
                layout.filters = '';
            } else {
                layout.filter = name;
                layout.filter_intensity = intensity;
            }

            let effectName = '';
            let effectIntensity = 100;

            if (!this.isEmptyFilter(layout.effects)) {
                effectName = String(layout.effects).split(':')[0];
                effectIntensity = String(layout.effects).split(':')[1] || 100;
            } else if (!this.isEmptyFilter(layout.effect)) {
                effectName = layout.effect;
                effectIntensity = layout.effect_intensity || 100;
            }

            if (this.isEmptyFilter(effectName)) {
                layout.effect = '';
                layout.effect_intensity = 100;
                layout.effects = '';
                return;
            }

            layout.effect = effectName;
            layout.effect_intensity = effectIntensity;
        },
        goBack: function () {
            this.$router.push('/posts');
        },
        insertAt(str, sub, pos) {
            return `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
        },
        formatStartTime(event, index, object) {
            this.client_parts[index][object] = this.client_parts[index][object].replace(',', '.')
        },
        formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.')
        },
        formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.')
        },
        formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.')
        },
        copyPart() {

            let part = JSON.parse(JSON.stringify(this.post.parts[this.active_part_index]));
            part.n = this.post.parts.length + 1;
            delete part.id;
            this.post.parts.push(part);

            this.selectPart(this.post.parts.length - 1);

        },
        addLayout(copy = false) {
            let self = this;

            // if copied
            if (copy !== false) {

                let copiedLayout = JSON.parse(JSON.stringify(self.template.layouts[self.active_layout]));
                copiedLayout.z_index = 0;

                self.template.layouts.push(copiedLayout);

                if (self.positions[self.active_layout]) {
                    self.positions.push(JSON.parse(JSON.stringify(self.positions[self.active_layout])));
                } else {
                    self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));
                }

                self.active_layout = self.template.layouts.length - 1;
                self.active_type = 'layout';

            } else {
                self.default_layout.z_index = 0;
                self.template.layouts.push(JSON.parse(JSON.stringify(self.default_layout)));
                self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                self.active_layout = self.template.layouts.length - 1;
                self.active_type = 'layout';

            }
        },
        addText(copy = false, tool = false) {
            let self = this;

            // if copied
            if (copy !== false) {
                let copiedText = JSON.parse(JSON.stringify(self.template.texts[self.active_text]));
                copiedText.z_index = self.template.texts.length + self.template.objects.length + 1;
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                let positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(JSON.stringify(positions)));

                setTimeout(() => {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                let newText = JSON.parse(JSON.stringify(self.default_text))

                if (tool) {
                    newText.type = 1;
                    newText.background_color = '#448AF7';
                }

                self.default_text.z_index = self.template.texts.length + self.template.objects.length + 1;
                self.template.texts.push(newText);
                self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }

        },
        addObject(object, copy = false) {
            let self = this;

            // if copied
            if (copy !== false) {
                let copiedObject = JSON.parse(JSON.stringify(self.template.objects[self.active_object]));
                copiedObject.z_index = self.template.texts.length + self.template.objects.length + 1;

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(JSON.stringify(self.object_positions[self.active_object])));

                setTimeout(() => {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object'

                }, 100);
            } else {
                self.placeGraphicObject(object);
            }


            self.active_object_category = 'Arrows';

        },
        addFrame(frame, copy = false) {
            let self = this;

            if (!self.template.frames) {
                self.template.frames = [];
            }

            if (copy !== false) {
                let copiedFrame = JSON.parse(JSON.stringify(self.template.frames[self.active_frame]));

                self.template.frames.push(copiedFrame);
                self.frame_positions.push(JSON.parse(JSON.stringify(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);

                self.$nextTick(() => {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            } else if (self.is_frame_changing) {
                let current = self.template.frames[self.active_frame];
                current.id = frame.id;
                current.src = frame.src;
                current.layouts = frame.layouts;
                self.is_frame_changing = false;
                self.show_frames_modal = false;
            } else {
                self.template.frames.push({
                    id: frame.id,
                    src: frame.src,
                    z_index: 1,
                    angle: 0,
                    alpha: 1,
                    layouts: frame.layouts,
                    w: 0,
                    x: 0,
                    y: 0,
                    rawData: {
                        original_w: 1080,
                        w: 540,
                        x: 0,
                        y: 0,
                    }
                });

                self.frame_positions.push(JSON.parse(JSON.stringify(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);
                self.show_frames_modal = false;

                self.$nextTick(() => {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            }
        },
        changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        changeFrame() {
            this.is_frame_changing = true;
            this.show_frames_modal = true;
        },
        addCollage(e) {
            // 888
            let data = e.target.dataset.params;
            let params = data.split(';');
            let id = params[0];
            let part = params[1]
            let x = params[2]
            let y = params[3]
            let w = params[4]
            let h = params[5]

            this.client_parts[this.active_part_index].collage_type = `${id};${part}`;
            this.client_parts[this.active_part_index].frame = {
                x: parseFloat(x),
                y: parseFloat(y),
                w: parseFloat(w),
                h: parseFloat(h)
            };

            this.previous_collage_id = id;

            this.show_collage_modal = false;
        },
        convertCollageTypeToNewFormat(oldType) {

            if (oldType.toString().indexOf('_') > 0) return oldType;

            let oldTypeName = _.find(this.collage_types, (c) => c.id === parseInt(oldType)).name
            let oldCategory = oldTypeName.split('/');
            let collageCategory = parseInt(oldCategory[1]) === 6 ? 6 : 1;

            return `${oldCategory[1]}_${collageCategory};${oldCategory[0]}`;
        },
        convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        updatePartsOrder() {
            if (this.template.n) {
                this.post.parts = _.sortBy(this.post.parts, 'n');
            }
        },
        toggleVideoPreview() {
            if (!this.template.video_preview) {
                this.template.video_src = null;
                this.template.video_src_full = null;
                this.template.video_src_size = 0;
            }
        },
        addPart() {

            let part = JSON.parse(JSON.stringify(this.default_part));
            part.n = this.post.parts.length + 1;
            part.layouts.push(JSON.parse(JSON.stringify(this.default_layout)));
            this.post.parts.push(part);

            this.selectPart(this.post.parts.length - 1);
        },
        removePart() {
            let self = this;
            let index = this.active_part_index;

            if (self.post.parts.length === 1) {
                alert('Нельзя удалить последний слайд')
                return;
            }

            if (confirm("Подтверждение удаления слайда " + (parseInt(index) + 1))) {
                self.active_part_index = 0;
                self.active_type = 'layout'

                self.post.parts = self.post.parts.filter((t, i) => i !== index);
            }
        },
        async selectPart(part) {

            //this.textWaiting = true;

            this.template = this.post.parts[part]

            // if (this.template.objects.length < 1) {
            //     this.template.objects = [];
            //     this.object_positions = [];
            // }

            this.object_positions = [];

            if (this.template.objects.length > 0) {


                for (let i = 0; i < this.template.objects.length; i++) {

                    this.object_positions.push(JSON.parse(JSON.stringify(this.default_positions)));

                    if (this.template.objects[i].id.indexOf('.svg') > -1) {

                        let dataSource = await axios.get(
                            `${this.$hostname}/admin/services/graphics/svg/source`,
                            {
                                'params': {
                                    url: this.graphicsUrl + this.template.objects[i].id,
                                },
                                'headers': {
                                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                                }
                            })

                        this.template.objects[i].source = dataSource.data


                    } else {
                        if (this.isGifSrc(this.template.objects[i].id) || !this.template.objects[i].dimensions) {
                            try {
                                const size = await this.loadRasterGraphic(this.template.objects[i].id);
                                if (size && !this.template.objects[i].dimensions) {
                                    this.$set(this.template.objects[i], 'dimensions', size);
                                }
                            } catch (e) {
                                console.log(e);
                            }
                        }
                        this.template.objects[i].source = "Image"
                    }

                    this.template.objects[i].is_visible = 1;
                    this.$nextTick(() => {
                        this.applyObjectContainerPosition(i);
                    });

                }

                this.$nextTick(() => {
                    this.applyAllObjectContainerPositions();
                });

            }

            if (this.template.texts.length > 0) {

                for (let i = 0; i < this.template.texts.length; i++) {
                    this.positions.push(this.default_positions);

                    if (!this.template.texts[i].angle) {
                        this.template.texts[i].angle = 0;
                    }

                    this.textWaiting = true;

                    setTimeout(() => {

                        if (this.$refs.draggableContainer[i]) {
                            if (this.$refs.draggableContainer[i].clientHeight < 1) {
                                console.log('2275');
                                location.reload();
                            }
                            let centerX = this.template.texts[i].position_x * 360 - this.$refs.draggableContainer[i].clientWidth / 2;
                            let centerY = this.template.texts[i].position_y * this.heightCanvas - this.$refs.draggableContainer[i].clientHeight / 2;

                            this.$refs.draggableContainer[i].style.left = centerX + 'px';
                            this.$refs.draggableContainer[i].style.top = centerY + 'px';
                        }

                        this.textWaiting = false;

                    }, 1000);
                }
            }

            this.frame_positions = [];
            if ((this.template.frames || []).length > 0) {
                for (let i = 0; i < this.template.frames.length; i++) {
                    this.frame_positions.push(JSON.parse(JSON.stringify(this.default_positions)));
                }

                setTimeout(() => {
                    for (let i = 0; i < this.template.frames.length; i++) {
                        this.applyFrameContainerPosition(i);
                    }
                }, 1000);
            }

            this.textWaiting = false;

            if (this.template.layouts.length > 0) {
                this.active_layout = 0;
                this.active_type = 'layout';
            } else {
                this.active_frame = 0;
                this.active_type = 'frame';
            }

            this.active_part_index = part;

            if (this.unsavedSnapshot === null) {
                this.captureUnsavedSnapshot();
            }

        },
        selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectLayout(layout) {
            this.active_layout = layout;
            this.active_type = 'layout';
        },
        selectFrame(frame) {
            this.active_frame = frame;
            this.active_type = 'frame';
        },
        selectObjectCategory(category) {
            this.active_object_category = category;
        },
        selectFrameCategory(id) {
            this.active_frame_category = id;
        },
        selectCollageCategory(category) {
            this.active_collage_category = category;
        },
        calculateLayouts: function() {

            let parts = this.post.parts
            for (let i = 0; i < parts.length; i++) {
                let layouts = parts[i].layouts;

                for (let j = 0; j < layouts.length; j++) {
                    let layout = layouts[j].rawData;

                    let originalH = this.getOriginalH(layout.original_w);

                    layouts[j].data = {
                        w: parseFloat(parseFloat(layout.w) / parseFloat(layout.original_w)).toFixed(6),
                        h: parseFloat(parseFloat(layout.h) / parseFloat(originalH)).toFixed(6),
                        x: parseFloat(parseFloat(layout.x) / parseFloat(layout.original_w)).toFixed(6),
                        y: parseFloat(parseFloat(layout.y) / parseFloat(originalH)).toFixed(6),
                        b_tl: parseFloat(parseFloat(layout.b_tl) / parseFloat(layout.w)).toFixed(6),
                        b_tr: parseFloat(parseFloat(layout.b_tr) / parseFloat(layout.w)).toFixed(6),
                        b_br: parseFloat(parseFloat(layout.b_br) / parseFloat(layout.w)).toFixed(6),
                        b_bl: parseFloat(parseFloat(layout.b_bl) / parseFloat(layout.w)).toFixed(6),
                    }

                }


                let frames = parts[i].frames;
                for (let j = 0; j < frames.length; j++) {
                    this.syncFrameCalculationsForFrame(frames[j]);
                }

            }

        },
        syncFrameCalculations(index) {
            let frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return;
            }
            this.syncFrameCalculationsForFrame(frame);
        },
        syncFrameCalculationsForFrame(frame) {
            let originalH = this.getOriginalH(frame.rawData.original_w);

            frame.w = parseFloat(parseFloat(frame.rawData.w) / parseFloat(frame.rawData.original_w)).toFixed(6)
            frame.x = parseFloat(parseFloat(frame.rawData.x) / parseFloat(frame.rawData.original_w)).toFixed(6)
            frame.y = parseFloat(parseFloat(frame.rawData.y) / parseFloat(originalH)).toFixed(6)
        },
        applyFrameContainerPosition(index) {
            let frame = this.template.frames[index];
            let containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            let scale = 360 / parseFloat(frame.rawData.original_w);
            containers[index].style.left = (parseFloat(frame.rawData.x) * scale) + 'px';
            containers[index].style.top = (parseFloat(frame.rawData.y) * scale) + 'px';
        },
        onFrameRawDataChange() {
            this.syncFrameCalculations(this.active_frame);
            this.applyFrameContainerPosition(this.active_frame);
        },
        updateFramePositionFromDom(index) {
            let frame = this.template.frames[index];
            let containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            let scale = 360 / parseFloat(frame.rawData.original_w);
            frame.rawData.x = parseFloat((containers[index].offsetLeft / scale).toFixed(2));
            frame.rawData.y = parseFloat((containers[index].offsetTop / scale).toFixed(2));
            this.syncFrameCalculations(index);
        },
        getOriginalH(originalW) {
            originalW = parseFloat(originalW);
            let ratio = parseInt(this.post.ratio);

            if (ratio === 2) {
                return originalW * 810 / 1080;
            }

            if (ratio === 3) {
                return originalW / 9 * 16;
            }

            if (ratio === 4) {
                return originalW;
            }

            return originalW / 4 * 5;
        },
        removeLayout(index) {
            let self = this;
            //
            // if (self.template.layouts.length === 1) {
            //     alert('Нельзя удалить последний layout')
            //     return;
            // }

            if (confirm("Подтверждение удаления layout " + (parseInt(index) + 1))) {

                self.template.layouts = self.template.layouts.filter((t, i) => i !== index);

                if (self.template.layouts.length > 0) {
                    self.active_layout = self.template.layouts.length - 1;
                    self.active_type = 'layout'
                } else {
                    if (self.template.frames.length > 0) {
                        self.active_frame = 0;
                        self.active_type = 'frame'
                    } else {
                        self.active_text = 0;
                        self.active_type = 'text'
                    }
                }
            }
        },
        removeFrame(index) {
            let self = this;

            if (confirm("Подтверждение удаления фрейма " + (parseInt(index) + 1))) {
                self.active_layout = 0;
                self.active_type = 'layout'

                self.template.frames = self.template.frames.filter((t, i) => i !== index);
                self.frame_positions = self.frame_positions.filter((t, i) => i !== index);
            }
        },
        removeText(index) {
            let self = this;

            if (confirm("Подтверждение удаления текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text'

                self.template.texts = self.template.texts.filter((t, i) => i !== index);
            }

            if (self.template.texts.length < 1) {
                self.active_layout = 0;
                self.active_type = 'layout'
            }
        },
        removeObject(index) {
            let self = this;

            if (confirm("Подтверждение удаления объекта")) {
                self.active_object = 0;
                self.active_type = 'object'

                self.template.objects = self.template.objects.filter((t, i) => i !== index);
            }

            if (self.template.objects.length < 1) {
                self.active_layout = 0;
                self.active_type = 'layout'
            }
        },
        toggleText() {
            let self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(JSON.stringify(self.default_text)));
                self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));
                self.active_type = 'text';

                setTimeout(() => {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';

                }, 500);
            } else {
                self.template.texts = [];
                self.template.objects = [];
                self.positions = [];
            }
        },
        toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },
        setTextPosition: function (x, y) {
            // x = parseFloat(x);
            // y = parseFloat(y);

            if (x) {
                this.template.texts[this.active_text].position_x = x;

                let centerX = x * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                let centerY = y * this.heightCanvas - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function (x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;
            }

            this.applyObjectContainerPosition(this.active_object);
        },
        onNudgeKeydown: function (event) {
            if (!this.template) {
                return;
            }

            if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                return;
            }

            let target = event.target;
            let tag = target && target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (target && target.isContentEditable)) {
                return;
            }

            if (this.show_svg_modal || this.show_frames_modal || this.show_collage_modal) {
                return;
            }

            let dx = 0;
            let dy = 0;
            if (event.key === 'ArrowLeft') {
                dx = -1;
            } else if (event.key === 'ArrowRight') {
                dx = 1;
            } else if (event.key === 'ArrowUp') {
                dy = -1;
            } else if (event.key === 'ArrowDown') {
                dy = 1;
            }

            if (!this.nudgeSelectedLayer(dx, dy)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
        },
        nudgeSelectedLayer: function (dx, dy) {
            if (this.active_type === 'text') {
                return this.nudgeText(dx, dy);
            }
            if (this.active_type === 'object') {
                return this.nudgeObject(dx, dy);
            }
            if (this.active_type === 'frame') {
                return this.nudgeFrame(dx, dy);
            }
            return false;
        },
        nudgeText: function (dx, dy) {
            let index = this.active_text;
            let text = this.template.texts[index];
            let containers = this.$refs.draggableContainer;
            if (!text || !containers || !containers[index]) {
                return false;
            }

            let step = 0.0005;
            text.position_x = parseFloat((parseFloat(text.position_x) + dx * step).toFixed(4));
            text.position_y = parseFloat((parseFloat(text.position_y) + dy * step).toFixed(4));

            let el = containers[index];
            el.style.left = (text.position_x * 360 - el.clientWidth / 2) + 'px';
            el.style.top = (text.position_y * this.heightCanvas - el.clientHeight / 2) + 'px';
            return true;
        },
        nudgeObject: function (dx, dy) {
            let index = this.active_object;
            let obj = this.template.objects[index];
            if (!obj) {
                return false;
            }

            let step = 0.0005;
            obj.position_x = parseFloat((parseFloat(obj.position_x) + dx * step).toFixed(4));
            obj.position_y = parseFloat((parseFloat(obj.position_y) + dy * step).toFixed(4));
            this.applyObjectContainerPosition(index);
            return true;
        },
        nudgeFrame: function (dx, dy) {
            let index = this.active_frame;
            let frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return false;
            }

            frame.rawData.x = parseFloat((parseFloat(frame.rawData.x) + dx).toFixed(2));
            frame.rawData.y = parseFloat((parseFloat(frame.rawData.y) + dy).toFixed(2));
            this.syncFrameCalculations(index);
            this.applyFrameContainerPosition(index);
            return true;
        },
        nudgeLayout: function (dx, dy) {
            let layout = this.template.layouts[this.active_layout];
            if (!layout || !layout.rawData) {
                return false;
            }

            layout.rawData.x = parseFloat((parseFloat(layout.rawData.x) + dx).toFixed(2));
            layout.rawData.y = parseFloat((parseFloat(layout.rawData.y) + dy).toFixed(2));
            return true;
        },
        changeRatioType() {
            let sizes = this.getRatioSizes(this.post.ratio);
            this.heightCanvas = sizes.heightCanvas;
            this.default_layout.rawData.h = sizes.layoutH;

            if (this.post.parts) {
                this.post.parts.forEach(part => {
                    (part.layouts || []).forEach(layout => {
                        if (!layout.rawData) {
                            return;
                        }
                        let w = parseFloat(layout.rawData.w);
                        let h = parseFloat(layout.rawData.h);
                        if (w === 1080 && (h === 1350 || h === 1920 || h === 810 || h === 1080)) {
                            layout.rawData.h = sizes.layoutH;
                        }
                    });
                });
            }

            if (this.active_part_index !== null) {
                this.selectPart(this.active_part_index);
            }
        },
        getRatioSizes(ratio) {
            ratio = parseInt(ratio);
            if (ratio === 2) {
                return { heightCanvas: Math.round(360 * 810 / 1080), layoutH: 810 };
            }
            if (ratio === 3) {
                return { heightCanvas: 640, layoutH: 1920 };
            }
            if (ratio === 4) {
                return { heightCanvas: 360, layoutH: 1080 };
            }
            return { heightCanvas: 450, layoutH: 1350 };
        },
        changeWidgetType(index, type) {
            const current = (this.template.texts[this.active_text].background_color || '').toUpperCase();
            const isCustom = current && current !== 'TRANSPARENT' && current !== '#448AF7' && current !== '#888888';
            if (isCustom) {
                return;
            }
            if (type === 1 || type === 5 || type === 7) {
                this.template.texts[this.active_text].background_color = '#448AF7';
            }
            if (type === 2 || type === 3 || type === 4 || type === 6) {
                this.template.texts[this.active_text].background_color = '#888888';
            }
        },
        setColor: function (color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        getContentColor: function (color) {
            if (color && color[0] === '#') {
                return color;
            } else {
                return '#000000'
            }
        },
        isColor: function (color) {
            return color && color[0] === '#'
        },
        isContentCorrected: function (content) {
            return content && content[0] !== '#';
        },
        setObjColor: function (color) {
            this.template.objects[this.active_object].color = color;
        },
        get: function (id) {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/posts/${this.id}`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(async function (response) {

                    let data = response.data;

                    let sizes = self.getRatioSizes(data.ratio);
                    self.heightCanvas = sizes.heightCanvas;
                    self.default_layout.rawData.h = sizes.layoutH;

                    for (let k = 0; k < data.parts.length; k++) {
                        let part = data.parts[k]

                        for (let i = 0; i < part.texts.length; i++) {

                            let text = _.find(self.fonts, (f) => f.name === part.texts[i].font_name);
                            if (!text) {
                                alert('Шрифт ' + part.texts[i].font_name + ' не найден. Пожалуйста, замените на другой.');
                            }

                            part.texts[i].is_visible = 1;
                            if (part.texts[i].time_start === undefined) {
                                part.texts[i].time_start = 0;
                            }
                            if (part.texts[i].time_end === undefined) {
                                part.texts[i].time_end = "";
                            }

                            if (!part.texts[i].angle) {
                                part.texts[i].angle = 0;
                            }

                            if (!part.texts[i].direction) {
                                part.texts[i].direction = "normal";
                            }

                            if (!part.texts[i].animation_type) {
                                part.texts[i].animation_type = 0;
                                part.texts[i].animation_duration = 0;
                            }

                            if (!part.texts[i].shadow_blur) {
                                part.texts[i].shadow_blur = 0;
                            }

                            if (!part.texts[i].shadow_distance) {
                                part.texts[i].shadow_distance = 0;
                            }

                            if (!part.texts[i].shadow_alpha) {
                                part.texts[i].shadow_alpha = 0;
                            }

                            if (!part.texts[i].shadow_color) {
                                part.texts[i].shadow_color = '#000000';
                            }

                            if (!part.texts[i].stroke_size) {
                                part.texts[i].stroke_size = 0;
                            }

                            if (!part.texts[i].stroke_size) {
                                part.texts[i].stroke_color = '#000000';
                            }

                            if (!part.texts[i].is_text_brush) {
                                part.texts[i].text_brush_data = [];
                            }

                            if (!part.texts[i].bg_alpha) {
                                part.texts[i].bg_alpha = 1;
                            }
                        }

                        for (let i = 0; i < part.objects.length; i++) {
                            if (!part.objects[i].animation_type) {
                                part.objects[i].animation_type = 0;
                                part.objects[i].animation_duration = 0;
                            }

                            if (!part.objects[i].shadow_blur) {
                                part.objects[i].shadow_blur = 0;
                            }

                            if (!part.objects[i].shadow_distance) {
                                part.objects[i].shadow_distance = 0;
                            }

                            if (!part.objects[i].shadow_alpha) {
                                part.objects[i].shadow_alpha = 0;
                            }

                            if (!part.objects[i].shadow_color) {
                                part.objects[i].shadow_color = '#000000';
                            }

                        }

                        for (let i = 0; i < part.layouts.length; i++) {
                            if (!part.layouts[i].stroke_size) {
                                part.layouts[i].stroke_size = 0;
                                part.layouts[i].stroke_color = '#000000';
                            }

                            if (!part.layouts[i].layout_type) {
                                part.layouts[i].layout_type = 1;
                            }

                            self.normalizeLayoutFilter(part.layouts[i]);
                        }


                    }

                    data.v_nola = data.v_nola || '';
                    data.sort_nola = data.sort_nola != null && data.sort_nola !== '' ? data.sort_nola : (data.sort || 0);
                    self.post = data;
                    //self.parts = self.post.parts;
                    self.post.parts = _.sortBy(self.post.parts, 'n');

                    self.selectPart(0)


                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        getResources: function () {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/resources/`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.server_effects = response.data.effects;
                    self.server_graphics = response.data.graphics;
                    self.server_filters = response.data.filters;
                    self.server_fonts = response.data.fonts;
                    self.server_frames = response.data.frames;

                    self.appendFonts();

                    self.get(self.id);
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        appendFonts: function () {

            let newStyle = document.createElement('style');
            for (let i = 0; i < this.server_fonts.length; i++) {
                let font = this.server_fonts[i];

                newStyle.appendChild(document.createTextNode(`
                    @font-face {
                      font-family: '${font.name}';
                      src: url('/static/fonts/${font.src}');
                    }
                    `));

                this.fonts.push({
                    params: `'${font.name}', sans-serif;`,
                    code: font.name,
                    name: font.name,
                })
            }

            document.head.appendChild(newStyle);

        },
        showSVGModal: function () {
            this.is_object_changing = false;
            this.show_svg_modal = true;
        },
        showFramesModal: function () {
            this.is_frame_changing = false;
            this.show_frames_modal = true;
        },
        closeSVGModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'Arrows';
            }
        },
        closeFramesModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_frames_modal = false;
                this.is_frame_changing = false;
            }
        },
        //'888'
        showCollageModal: function (index) {
            this.active_part_index = index;
            this.show_collage_modal = true;
        },
        closeCollageModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_collage_modal = false;
            }
        },
        save: function () {
            let self = this;

            this.calculateLayouts();

            let post = JSON.parse(JSON.stringify(this.post));
            post.media_count = this.calculatedMediaCount;

       console.log(post);

            self.waiting = true;

            setTimeout(() => {

                for (let p = 0; p < post.parts.length; p++) {

                    let template = post.parts[p];

                    for (let i = 0; i < template.texts.length; i++) {

                        let activeText = template.texts[i];

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.position_x = parseFloat(activeText.position_x);
                        activeText.position_y = parseFloat(activeText.position_y);
                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.bg_alpha = parseFloat(activeText.bg_alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_distance = parseFloat(activeText.shadow_distance);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        activeText.text_brush_data = activeText.is_text_brush ? activeText.text_brush_data : [];

                        template.texts[i] = activeText;

                    }

                    for (let i = 0; i < template.objects.length; i++) {

                        let activeObj = template.objects[i];

                        activeObj.position_x = parseFloat(activeObj.position_x);
                        activeObj.position_y = parseFloat(activeObj.position_y);
                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.shadow_distance = parseFloat(activeObj.shadow_distance);
                        activeObj.shadow_alpha = parseFloat(activeObj.shadow_alpha);
                        activeObj.shadow_blur = parseInt(activeObj.shadow_blur);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[i] = activeObj;

                    }

                    for (let i = 0; i < template.layouts.length; i++) {

                        let activeLayout = template.layouts[i];

                        activeLayout.co = activeLayout.is_content ? activeLayout.co ? activeLayout.co : '' : '';
                        activeLayout.alpha = parseFloat(activeLayout.alpha);
                        activeLayout.angle = parseInt(activeLayout.angle);
                        activeLayout.z_index = parseInt(activeLayout.z_index);

                        if (self.isEmptyFilter(activeLayout.filter)) {
                            activeLayout.filter = "";
                            activeLayout.filter_intensity = 100;
                            activeLayout.filters = "";
                        } else {
                            activeLayout.filter_intensity = parseInt(activeLayout.filter_intensity) || 100;
                            activeLayout.filters = activeLayout.filter + ":" + activeLayout.filter_intensity;
                        }

                        if (self.isEmptyFilter(activeLayout.effect)) {
                            activeLayout.effect = "";
                            activeLayout.effect_intensity = 100;
                            activeLayout.effects = "";
                        } else {
                            activeLayout.effect_intensity = parseInt(activeLayout.effect_intensity) || 100;
                            activeLayout.effects = activeLayout.effect + ":" + activeLayout.effect_intensity;
                        }

                        delete activeLayout.co_full;
                        delete activeLayout.co_size;

                        template.layouts[i] = activeLayout;

                    }

                    for (let i = 0; i < template.frames.length; i++) {

                        let activeFrame = template.frames[i];

                        activeFrame.alpha = parseFloat(activeFrame.alpha);
                        activeFrame.angle = parseInt(activeFrame.angle);
                        activeFrame.z_index = parseInt(activeFrame.z_index);

                        template.frames[i] = activeFrame;
                    }

                }
console.log(post);

                axios.post(
                    `${this.$hostname}/admin/posts/${this.id}/update`,
                    post,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {
                        const notification = {
                            template: `<span><b>Шаблон был успешно изменен</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            })

                        self.waiting = false;
                        self.captureUnsavedSnapshot();

//                    self.$router.push('/posts');
                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })

                        self.waiting = false;
                    });


            }, 200);


        },
        remove: function () {
            let self = this;

            if (confirm("Внимание! Подтверждение удаления шаблона: " + self.id)) {
                axios.post(
                    `${this.$hostname}/admin/posts/${this.id}/delete`,
                    this.template,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {
                        const notification = {
                            template: `<span><b>Шаблон был успешно удален</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            });

                        self.allowUnsavedLeave = true;
                        self.$router.push('/posts');
                    })
                    .catch(function (error) {

                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })

                    });
            }

        },
        clickContentFileButton: function (index) {
            let ref = (_.get(this.$refs, `contentFileInput_${index}`));
            ref[0].click();
        },
        uploadFile: function (event, type, index) {
            let self = this;

            let formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {
                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                if (type === 'preview_src') {
                    self.post[data.file_type] = data.url;
                    self.post[data.file_type + '_full'] = data.url_full;
                    self.post[data.file_type + '_size'] = data.filesize;
                }

                if (type === 'src') {
                    self.template[data.file_type] = data.url;
                    self.template[data.file_type + '_full'] = data.url_full;
                    self.template[data.file_type + '_size'] = data.filesize;
                }

                if (type === 'video_src') {
                    self.template[data.file_type] = data.url;
                    self.template[data.file_type + '_full'] = data.url_full;
                    self.template[data.file_type + '_size'] = data.filesize;
                }

                if (type === 'co') {

                    self.template.layouts[self.active_layout][data.file_type] = data.url;
                    self.template.layouts[self.active_layout][data.file_type + '_full'] = data.url_full;
                    self.template.layouts[self.active_layout][data.file_type + '_size'] = data.filesize;
                }

            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },
        dragMouseDown: function (event) {
            event.preventDefault()

            let path = event.composedPath ? event.composedPath() : event.path;
            let id = null;
            _.each(path, (p) => {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            })

            if (!id) {
                return;
            }

            this.preview_drag_start = { x: event.clientX, y: event.clientY };
            this.preview_drag_moved = false;

            if (id.indexOf('o') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX
                this.object_positions[this.draggable_index].clientY = event.clientY
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = '0.6'

                document.onmousemove = this.objectDrag
                document.onmouseup = this.closeDragObject
            } else if (id.indexOf('f') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'frame';

                if (!this.frame_positions[this.draggable_index]) {
                    this.$set(this.frame_positions, this.draggable_index, JSON.parse(JSON.stringify(this.default_positions)));
                }

                this.frame_positions[this.draggable_index].clientX = event.clientX
                this.frame_positions[this.draggable_index].clientY = event.clientY
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = '0.6'

                document.onmousemove = this.frameDrag
                document.onmouseup = this.closeDragFrame
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX
                this.positions[this.draggable_index].clientY = event.clientY
                this.$refs.draggableContainer[this.draggable_index].style.opacity = '0.6'

                document.onmousemove = this.textDrag
                document.onmouseup = this.closeDragText
            }
        },
        markPreviewDragIfMoved: function (event) {
            if (this.preview_drag_moved || !this.preview_drag_start) {
                return;
            }

            let dx = event.clientX - this.preview_drag_start.x;
            let dy = event.clientY - this.preview_drag_start.y;
            if (dx * dx + dy * dy > 0) {
                this.preview_drag_moved = true;
            }
        },
        selectPreviewIfClicked: function (type) {
            if (this.preview_drag_moved || this.draggable_index == null) {
                return;
            }

            let index = parseInt(this.draggable_index);
            if (type === 'text') {
                this.selectText(index);
            } else if (type === 'object') {
                this.selectObject(index);
            } else if (type === 'frame') {
                this.selectFrame(index);
            }
        },
        textDrag: function (event) {
            event.preventDefault()
            this.markPreviewDragIfMoved(event);

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY
            this.positions[this.draggable_index].clientX = event.clientX
            this.positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer[this.draggable_index].style.top =
                (this.$refs.draggableContainer[this.draggable_index].offsetTop
                    - this.positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer[this.draggable_index].style.left =
                (this.$refs.draggableContainer[this.draggable_index].offsetLeft
                    - this.positions[this.draggable_index].movementX) + 'px'

            let centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            let centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / this.heightCanvas).toFixed(4));
        },
        closeDragText() {
            document.onmouseup = null
            document.onmousemove = null

            if (this.draggable_index != null && this.$refs.draggableContainer[this.draggable_index]) {
                this.$refs.draggableContainer[this.draggable_index].style.opacity = ''
            }

            this.selectPreviewIfClicked('text');
            this.draggable_index = null

            return false;
        },
        objectDrag: function (event) {
            event.preventDefault()
            this.markPreviewDragIfMoved(event);

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY
            this.object_positions[this.draggable_index].clientX = event.clientX
            this.object_positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer2[this.draggable_index].style.top =
                (this.$refs.draggableContainer2[this.draggable_index].offsetTop
                    - this.object_positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer2[this.draggable_index].style.left =
                (this.$refs.draggableContainer2[this.draggable_index].offsetLeft
                    - this.object_positions[this.draggable_index].movementX) + 'px'

            this.syncObjectModelFromElement(this.draggable_index);
        },
        closeDragObject() {
            document.onmouseup = null
            document.onmousemove = null

            if (this.draggable_index != null && this.$refs.draggableContainer2[this.draggable_index]) {
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = ''
            }

            this.selectPreviewIfClicked('object');
            this.draggable_index = null

            return false;
        },
        frameDrag: function (event) {
            event.preventDefault()
            this.markPreviewDragIfMoved(event);

            this.frame_positions[this.draggable_index].movementX = this.frame_positions[this.draggable_index].clientX - event.clientX
            this.frame_positions[this.draggable_index].movementY = this.frame_positions[this.draggable_index].clientY - event.clientY
            this.frame_positions[this.draggable_index].clientX = event.clientX
            this.frame_positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer3[this.draggable_index].style.top =
                (this.$refs.draggableContainer3[this.draggable_index].offsetTop
                    - this.frame_positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer3[this.draggable_index].style.left =
                (this.$refs.draggableContainer3[this.draggable_index].offsetLeft
                    - this.frame_positions[this.draggable_index].movementX) + 'px'

            this.updateFramePositionFromDom(this.draggable_index);
        },
        closeDragFrame() {
            document.onmouseup = null
            document.onmousemove = null

            if (this.draggable_index != null && this.$refs.draggableContainer3[this.draggable_index]) {
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = ''
            }

            this.selectPreviewIfClicked('frame');
            this.draggable_index = null

            return false;
        },
        renderCollagePart(index) {
            let layout = index.split(';');

            if (index) {
                let category = layout[0].split('_')[0];
                let collageId = layout[0];
                let partId = parseInt(layout[1]);
                let collages = _.find(this.collages, (c) => c.name === category)
                let collage = _.find(collages.data, (c) => c.id === collageId)

                return this.renderCollage(collage, 0.7, partId - 1);
            }
        },
        renderCollage(layout, scale = 1, partId = null) {

            let palette = [
                "#FFDFBA","#FFFFBA","#BAFFC9","#BAE1FF",
                "#D7C4F3","#C1F0F6","#FAD6A5","#F7C5CC","#C9E4DE"
            ];

            let containerStyle =
                "position:relative;" +
                `width:${108 * scale}px;height:${192 * scale}px;` +
                "background:#f7f7f7;overflow:hidden;" +
                `border: 1px solid ${partId === null && this.previous_collage_id === layout.id ? 'red' : '#000'};` +
                "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            let html = '<div style="' + containerStyle + '">';

            for (let i = 0; i < layout.frames.length; i++) {
                let f = layout.frames[i];

                let left = f.x * 108 * scale;
                let top = f.y * 192 * scale;
                let width = f.width * 108 * scale;
                let height = f.height * 192 * scale;

                let color = palette[i % palette.length];

                let radiusStyle = "0px";
                if (f.crop && f.crop.type === "roundedCorner") {
                    let v = f.crop.value;
                    if (v < 0) v = 0;
                    if (v > 1) v = 1;
                    radiusStyle = (v * Math.min(width, height) / 2) + "px";
                }

                let frameStyle =
                    "position:absolute;" +
                    "left:" + left + "px;top:" + top + "px;" +
                    "width:" + width + "px;height:" + height + "px;" +
                    "background:" + color + ";" +
                    "border-radius:" + radiusStyle + ";overflow:hidden;" +
                    "display:flex;align-items:center;justify-content:center;" +
                    "color:rgba(0,0,0,.5);" +
                    "font:600 12px sans-serif;";

                let params = `${layout.id};${i + 1};${f.x};${f.y};${f.width};${f.height}`;

                html += `
                          <div
                            data-params="${params}"
                            class="collage-item-part ${partId === i ? 'diagonal-lines' : ''}"
                            style="${frameStyle}"
                          >
                            ${i + 1}
                          </div>
                        `;
            }

            html += "</div>";
            return html;
        },
        showPrevNext() {
            console.log('show')
        },
        toggleLayoutHighlight() {
            this.show_layout_highlight = !this.show_layout_highlight;
        }
    }
}

</script>
<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

.layers-sticky {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
}

.preview-sticky {
    position: sticky;
    z-index: 10;
}

.range {
    cursor: pointer !important;
}

#preview-container {
    display: block;
    margin: 0 auto 30px auto;
    width: 100%;
}

.object-preview {
    width: 100px;
    display: block;
    cursor: pointer;
    margin-bottom: 15px;
}

#preview {
    width: 360px;
    height: 450px;
    position: relative;
    display: inline-block;
    float: left;
    top: 0;
    z-index: 11;
    transition: all .3s ease-out;
}
#preview-previous, #preview-next {
    width: 200px;
    height: 450px;
    position: relative;
    display: inline-block;
    float: left;
    top: 0;
    opacity: 0;
    z-index: 11;
    transition: all .3s ease-out;
}
.preview-media {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
    pointer-events: none;
}

video::-webkit-media-controls-fullscreen-button {
    display: none !important;
}

.btn-layout-highlight {
    float: left;
    width: 36px;
    height: 36px;
    margin: 0 0 0 8px;
    padding: 0;
    background: transparent;
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    color: #c4c4c4;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-layout-highlight .layer-fill {
    fill: none;
}

.btn-layout-highlight:hover {
    color: #9a9a9a;
    border-color: #bdbdbd;
}

.btn-layout-highlight.active-state {
    background: rgba(29, 199, 234, 0.1);
    border-color: #c5e8ef;
    color: #8fc9d6;
}

.btn-layout-highlight.active-state .layer-fill {
    fill: currentColor;
}

.draggable-header {
    white-space: pre;
    cursor: pointer;
}

.draggable-header.active {
    outline: 1px solid #FFD700;
    outline-offset: 4px;
}

.draggable-header.nospace {
    white-space: normal;
    padding: 0;
}

.draggable-container {
    top: 0px;
    position: absolute;
}
#preview svg,
#preview img {
    display: block;
}

.text-area {
    width: 100%;
    padding: 8px 12px;
}

.btn-save {
    width: 150px;
}

.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.btn-text, .btn-text:active, .btn-text:hover {
    color: #000;
    background-color: #FFFFFF;
    border: 1px solid #000000;
    margin-right: 5px;
    margin-bottom: 5px;
}

.btn-text.active {
    color: #000;
    background-color: #D5C9E9;
    border: 1px solid #D5C9E9;
}

.btn-text:hover {
    opacity: 0.6;
}

.btn-text.control-btn {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
}

.button-preview {
    height: 20px;
    width: 70px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.button-preview:active {

}


.btn-remove, .btn-remove:active {
    color: rgba(255, 70, 50);
    border: 1px solid rgba(255, 70, 50);
    background-color: transparent;
    margin-top: 20px
}

.btn-delete-collage, .btn-delete-collage:active, .btn-delete-collage:hover, .btn-delete-collage:focus  {
    opacity: 0.5;
    font-size: 12px;
    color: rgba(255, 70, 50);
    border: 1px solid rgba(255, 70, 50);
    background-color: transparent;
    position: absolute;
    bottom: 5px;
    right: 20px;
}
.btn-delete-collage:hover {
    opacity: 0.3;
}

.checkbox-block {
    margin-top: 20px;
    margin-left: 20px;
}


.color-set span {
    width: 37px;
    height: 26px;
    display: inline-block;
    margin-left: 5px;
    border-radius: 5px;
    cursor: pointer;
}

.color-set span:first-child {
    border: 1px solid #E3E3E3;
}

.color-set span.active {
    border: 1px solid #000000;
}
.tags-set {
    margin-top: 8px;
}
.tags-set div {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 5px;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid #E3E3E3;
    font-size: 14px;
}
.tags-set div:hover {

}
.tags-set div.active {
    border: 1px solid transparent;
    background-color: #54abfe47;
}

.btn-file {
    display: none;
}

.upload-button {
    margin-top: 10px;
}

.inline-link {
    font-size: 16px;
    margin-left: 5px;
}

.inline-link span, h4 .bg-danger {
    padding: 3px;
    border-radius: 4px;
}

.bg-danger {
    font-size: 16px;
    background-color: rgba(255, 70, 50, 0.5) !important;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
    cursor: pointer;
}

.label-checkbox {
    margin-right: 10px;
    cursor: pointer;
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.mb10 {
    margin-bottom: 10px
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.param-span, .param-span label {
    font-size: 0.8rem;
    color: #000;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 1.7s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 1000px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 1.7s ease;
}


.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-header button {
    text-transform: capitalize;
}

.modal-body {
    margin: 20px 0;
    overflow: scroll;
    height: 500px;
}

.object-item, .frame-item {
    display: inline-block;
    max-width: 100px;
    height: 64px;
    margin-right: 20px;
    cursor: pointer;
    margin-bottom: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.collage-item {
    width: 108px;
    height: 192px;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
}
.collage-btn {
    margin-top: 25px;
    font-size: 12px;
}
.collage-category {
    padding-left: 40px;
    padding-right: 40px;
}

.object-item:first-child {
    margin-left: 0;
}

.object-item:hover {
    opacity: 0.6;
}

.object-item img {
    width: 100%;
    max-height: 64px;
    display: block;
}
.widget-icon {
    width: 120px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.frame-item {
    max-width: 100%;
    height: 200px;
}
.frame-item img {
    width: 100%;
    height: 100%;
    display: block;
}

.modal-header {
    padding-left: 0;
    display: block;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.texts-buttons button {
    position: relative;
}

.animated-icon {
    font-size: 30px;
    position: absolute;
    color: #6dc030;
    top: -15px;
    right: 0;
}

.effect-values, .cutout-preview {
    display: block;
    width: 100%;
    font-size: 10px;
    text-transform: uppercase;
    margin-left: 15px;
    color: #9A9A9A;
}

.effect-preview, .cutout-preview {
    width: 50px;
    height: 89px;
    margin-left: 9px;
    display: block;
    border: 1px solid #E3E3E3;
    cursor: pointer;
    position: relative;
}

.effect-area, .cutout-area {
    width: 30px;
    height: 30px;
    border: 1px solid #FFD700;
    border-radius: 50%;
    display: block;
    position: relative;
    top: 10px;
    left: 10px
}

.effect-center, .cutout-center {
    display: block;
    width: 8px;
    height: 8px;
    background: #FFD700;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    left: 10px;
}
.collage-preview {
    cursor: pointer;
    margin-left: 10px;

}
.cutout-area {
    border: 1px solid #2140f5;
}
.cutout-center {
    background: #2140f5;
}
.cutout-position {
    font-size: 13px;
}

.bordered:last-child {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 15px;
    margin-bottom: 15px;
}
.bordered-block {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 15px;
    margin-bottom: 15px;
}


.row {
    margin-right: -13px;
}

.ml9 {
    margin-left: 9px !important;
    margin-bottom: 15px;
}

.block-number {
    display: block;
    margin-top: 0;
    font-size: 38px;
    font-weight: 700;
    color: #000;
}
.realDuration, .partsDuration {
    font-size: 14px;
}
.realDuration span, .partsDuration span {
    font-size: 18px;
}
.btn-delete {
    margin-right: 20px;
    opacity: 0.1;
}
.preview-img {
    margin-top: 20px;
    margin-bottom: 20px;
    max-width: 300px;
    border: 1px solid rgba(204, 204, 204, 0.5);
    border-radius: 8px;
}
</style>

<style>

.modal-body .collage-item-part:hover {
    opacity: 0.6 !important;
}
.modal-body .collage-item-part:hover {
    position: relative;
    z-index: 0; /* важно, чтобы псевдоэлемент был поверх */
}
.modal-body .collage-item-part:hover::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none; /* чтобы клики проходили сквозь */
    border-radius: inherit;

    background-image: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 8px,
        rgba(0, 0, 0, 0.8) 9px,
        rgba(0, 0, 0, 0.8) 10px
    );
}

.diagonal-lines {
    position: relative;
    z-index: 0; /* важно, чтобы псевдоэлемент был поверх */
}

.diagonal-lines::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none; /* чтобы клики проходили сквозь */
    border-radius: inherit;

    background-image: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 8px,
        rgba(0, 0, 0, 0.8) 9px,
        rgba(0, 0, 0, 0.8) 10px
    );
}
.texts-buttons {
    margin-top: 30px;
}
.preview-slide {
    display: block;
    width: 92px;
    height: 115px;
    margin-right: 5px;
    float: left;
    background-size: contain;
    cursor: pointer;
}
.preview-slide:hover {
    outline: 2px solid red;
}
.preview-slide.active {
    outline: 2px solid red;
}
.add-part {
    outline: 1px solid black;
    background:
        url('/static/img/plus.png') center / 30px 30px no-repeat,
        #f5f5f5;
    padding: 0 0 0 3em;
}
.overlay {
    position: absolute;
    cursor: pointer;
}
.overlay.active {
    outline: 1px solid red;
}
.mt25 {
    margin-top: 25px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Posts/Edit.vue